import React, { Fragment, useEffect, useRef, useState } from "react";
import { backend, API_URL, STRIPE_KEY } from "../../../config";
import { Link } from "react-router-dom";
import {
  Button,
  Container,
  CssBaseline,
  Grid,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  useTheme,
  Modal,
  CircularProgress,
  Tooltip,
  TextField,
  InputAdornment,
  Stack,
  Autocomplete,
  FormControlLabel,
  Switch,
  Link as LinkE,
  Collapse,
  Chip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import "./Invoice.css";

import jsPDF from "jspdf";
import "jspdf-autotable";

import { loadStripe } from "@stripe/stripe-js";

import { Elements } from "@stripe/react-stripe-js";

import { useSelector } from "react-redux";
import { renderToString } from "react-dom/server";

import PrintIcon from "@mui/icons-material/Print";
import MailIcon from "@mui/icons-material/Mail";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import RefreshIcon from "@mui/icons-material/Refresh";
import SaveIcon from "@mui/icons-material/Save";
import CachedIcon from "@mui/icons-material/Cached";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PaidIcon from "@mui/icons-material/Paid";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from "@mui/icons-material/Info";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import LockIcon from "@mui/icons-material/Lock";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

import Logo from "../../../assets/images/logo.png";
import Payment from "../../../components/Forms/Payment/Payment";

const stripePromise = loadStripe(STRIPE_KEY);

const useStyles = makeStyles((theme) => ({
  tableBody: {
    "&:nth-of-type(even)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

const columns = [
  { id: "unit_quantity", label: "Unit Quantity", align: "center", width: 120 },
  { id: "case_quantity", label: "Case Quantity", align: "center", width: 120 },
  { id: "item_code", label: "Item Code", align: "center", width: 110 },
  { id: "name", label: "Description", align: "left" },
  { id: "unit_price", label: "Unit Price", align: "center", width: 110 },
  { id: "case_price", label: "Case Price", align: "center", width: 110 },
  { id: "total", label: "Amount", align: "center", width: 150 },
];

export const generateDocument = (invoice) => {
  const ffAddress = [
    "Friendly Foods, Inc.",
    "3336 S La Cienega Blvd Ste 113",
    "Los Angeles, CA 90016",
    "323-653-5900",
  ];

  const ffDisclaimer =
    "If at any time for any reason, customer fails to pay for the purchase of the invoiced goods and merchandise when due. Customer agrees to pay interest computed at the rate of 1 1/2% per month or the maximum amount allowed by law, whichever is less. In the event it becomes necessary to incur collection cost or institute a lawsuit to collect any amount due on this invoice or any portion thereof customer agrees to pay such additional collection costs, charges and expenses, including attorney fees pursuant to this invoice or CCP1717.5.";

  const dateOrderHeaders = [["Date", "Order #"]];
  const dateOrderData = [
    [invoice.order_delivery_date.split("T")[0], invoice.order_id],
  ];

  const billAddress =
    invoice.company_location_name + "\n" + invoice.bill_to_address;

  const billToHeaders = [["Bill To"]];
  const billToData = [[billAddress]];

  const shipAddress =
    invoice.company_location_name + "\n" + invoice.ship_to_address;

  const shipToHeaders = [["Ship To"]];
  const shipToData = [[shipAddress]];

  const shipFromAddress = "FF Warehouse\n" + invoice.ship_from_address;
  const shipFromHeaders = [["Ship From"]];
  const shipFromData = [[shipFromAddress]];

  const itemsHeaders = [
    [
      "Unit",
      "Case",
      "Item Code",
      "Description",
      "Unit Price",
      "Case Price",
      "Amount",
    ],
  ];

  const invoiceItemsMap = invoice.items; // splitItemsByUoM(invoice);
  const invoiceCreditsMap = invoice.credits;

  const itemsData = invoiceItemsMap.map((item) => {
    let itemObj = [
      item.unit_quantity > 0 ? item.unit_quantity : " ",
      item.case_quantity > 0 ? item.case_quantity : " ",
      item.item_code,
    ];

    let unitPrice =
      item.unit_quantity > 0
        ? `$${
            item.invoice_override_unit_price !== null
              ? item.invoice_override_unit_price.toFixed(2)
              : item.unit_price.toFixed(2)
          }${item.subitem_weight_lbs > 0 ? " / lb" : ""}`
        : " ";

    let casePrice =
      item.case_quantity > 0
        ? `$${
            item.invoice_override_case_price !== null
              ? item.invoice_override_case_price.toFixed(2)
              : item.case_price.toFixed(2)
          }${item.subitem_weight_lbs > 0 ? " / lb" : ""}`
        : " ";

    let amount =
      "$" +
      (item.invoice_override_total !== null
        ? item.invoice_override_total.toFixed(2)
        : item.total.toFixed(2));

    let descriptionStr = item.name; // item.name.length < 40 ? item.name : item.name.substr(0, 40);

    descriptionStr += orderItemsCellExtra(item, { id: "name" }, true);

    casePrice += orderItemsCellExtra(item, { id: "case_price" }, true);

    amount += orderItemsCellExtra(item, { id: "total" }, true);

    if (
      item.case_quantity > 0 &&
      item?.display_units_per_case_on_invoice &&
      item?.units_per_case &&
      item?.units_per_case > 1
    ) {
      descriptionStr += `\nUnits per case: ${item?.units_per_case}`;
    }

    itemObj.push(descriptionStr);

    itemObj.push(unitPrice);

    itemObj.push(casePrice);

    itemObj.push(amount);

    return itemObj;
  });

  const creditsDivider = [
    {
      content: "Credits",
      colSpan: 7,
      styles: {
        halign: "center",
        fontStyle: "bold",
        fillColor: [220, 220, 220],
      },
    },
  ];

  const itemsCreditData = invoiceCreditsMap.map((item) => {
    let descriptionStr = item.description;

    if (item?.reason || item?.invoice_reference) {
      descriptionStr += "\n";
    }

    if (item?.reason) {
      descriptionStr += `Reason: ${item.reason}`;
    }

    if (item?.invoice_reference) {
      descriptionStr += ` Reference: ${item.invoice_reference}`;
    }

    return [
      item.unit_quantity > 0 ? item.unit_quantity * -1 : " ",
      item.case_quantity > 0 ? item.case_quantity * -1 : " ",
      item.product_data?.item_code?.item_code || " ",
      descriptionStr || " ",
      item.unit_price && item.unit_quantity > 0
        ? `$${(+item.unit_price).toFixed(2)}`
        : " ",
      item.case_price && item.case_quantity > 0
        ? `$${(+item.case_price).toFixed(2)}`
        : " ",
      item.total ? `-$${(+item.total).toFixed(2)}` : " ",
    ];
  });

  const itemsDataFullBody =
    itemsCreditData.length > 0
      ? [...itemsData, creditsDivider, ...itemsCreditData]
      : itemsData;

  let summaryData = [["Subtotal: ", `$${invoice.subtotal.toFixed(2)}`]];

  if (invoice.credit_card_fee) {
    summaryData.push([
      "Credit Card Fee: ",
      `$${(invoice.credit_card_fee || 0).toFixed(2)}`,
    ]);
  }

  if (invoice.refrigerated_delivery_fee) {
    summaryData.push([
      "Refrigerated Delivery Fee: ",
      `$${(invoice.refrigerated_delivery_fee || 0).toFixed(2)}`,
    ]);
  }

  if (invoice.late_fee) {
    summaryData.push(["Late Fee:", ` $${(invoice.late_fee || 0).toFixed(2)}`]);
  }

  summaryData.push(["Taxes: ", `$${(invoice.tax_total || 0).toFixed(2)}`]);

  if (invoice.credit_total) {
    summaryData.push([
      "Credits: ",
      `$${(invoice.credit_total || 0).toFixed(2)}`,
    ]);
  }

  summaryData.push(["Grand Total: ", `$${invoice.grand_total.toFixed(2)}`]);

  // PDF
  // todo: simplify header drawer in a function
  const pdf = new jsPDF("p", "mm", "a4", false);

  pdf.autoTableSetDefaults({
    headStyles: { fillColor: [161, 49, 39] },
  });

  pdf.setFontSize(10);

  pdf.autoTable({
    head: itemsHeaders,
    body: itemsDataFullBody,
    columnStyles: {
      3: { halign: "left" },
    },
    styles: {
      halign: "center",
      valign: "middle",
    },
    rowPageBreak: "avoid",
    willDrawPage: (data) => {
      pdf.addImage(Logo, "PNG", 15, 15, 40, 26);
      pdf.setFontSize(10);
      pdf.text(ffAddress, 60, 20);

      pdf.setFontSize(14);
      pdf.text("Invoice", 150, 15);

      pdf.setFontSize(10);
      pdf.setFont("helvetica", "bold");
      pdf.text("Customer: ", 150, 22);

      pdf.setFont("helvetica", "normal");
      pdf.text(invoice.customer.username, 169, 22);

      pdf.autoTable({
        head: dateOrderHeaders,
        body: dateOrderData,
        startY: 25,
        margin: { left: 150 },
        styles: { overflow: "hidden", cellWidth: "wrap" },
      });

      const billShipY = pdf.lastAutoTable.finalY + 5;

      pdf.autoTable({
        head: billToHeaders,
        body: billToData,
        startY: billShipY,
        styles: { overflow: "hidden", cellWidth: "wrap" },
      });

      pdf.autoTable({
        head: shipToHeaders,
        body: shipToData,
        startY: billShipY,
        margin: { left: 80 },
        styles: { overflow: "hidden", cellWidth: "wrap" },
      });

      pdf.autoTable({
        head: shipFromHeaders,
        body: shipFromData,
        startY: billShipY,
        margin: { left: 150 },
        styles: { overflow: "hidden", cellWidth: "wrap" },
      });
    },
    margin: { top: 75 },
  });

  // note: we can add margin to the items table
  // margin: { bottom: 35 },

  const shouldAddPage = pdf.lastAutoTable.finalY > 237.45;

  if (shouldAddPage) {
    pdf.addPage("p", "mm", "a4", false);

    pdf.addImage(Logo, "PNG", 15, 15, 40, 26);
    pdf.setFontSize(10);
    pdf.text(ffAddress, 60, 20);

    pdf.setFontSize(14);
    pdf.text("Invoice", 150, 15);

    pdf.setFontSize(10);
    pdf.setFont("helvetica", "bold");
    pdf.text("Customer: ", 150, 22);

    pdf.setFont("helvetica", "normal");
    pdf.text(invoice.customer.username, 169, 22);

    pdf.autoTable({
      head: dateOrderHeaders,
      body: dateOrderData,
      startY: 25,
      margin: { left: 150 },
      styles: { overflow: "hidden", cellWidth: "wrap" },
    });

    const billShipY = pdf.lastAutoTable.finalY + 5;

    pdf.autoTable({
      head: billToHeaders,
      body: billToData,
      startY: billShipY,
      styles: { overflow: "hidden", cellWidth: "wrap" },
    });

    pdf.autoTable({
      head: shipToHeaders,
      body: shipToData,
      startY: billShipY,
      margin: { left: 80 },
      styles: { overflow: "hidden", cellWidth: "wrap" },
    });

    pdf.autoTable({
      head: shipFromHeaders,
      body: shipFromData,
      startY: billShipY,
      margin: { left: 150 },
      styles: { overflow: "hidden", cellWidth: "wrap" },
    });
  }

  let defaultStartY = shouldAddPage ? 75 : pdf.lastAutoTable.finalY + 5;
  let disclaimerPrinted = false;

  pdf.autoTable({
    body: summaryData,
    startY: defaultStartY,
    styles: {
      halign: "right",
    },
    columnStyles: {
      0: { fontStyle: "bold" },
    },
    margin: { left: 125 },
    willDrawCell: (data) => {
      var rows = data.table.body;
      if (data.row.index === rows.length - 1) {
        data.cell.styles.lineColor = "black";
        data.cell.styles.lineWidth = {
          top: 1,
          right: 1,
          bottom: 1,
          left: 1,
        };

        if (data.cell.raw === "Grand Total: ") {
          data.cell.styles.lineWidth.right = 0;
        } else {
          data.cell.styles.lineWidth.left = 0;
        }
      }
    },
    willDrawPage: (data) => {
      if (data.cursor.y < data.settings.startY) {
        defaultStartY = 14;
      }

      if (!disclaimerPrinted) {
        disclaimerPrinted = true;

        pdf.setFontSize(6);
        pdf.text(ffDisclaimer, 15, defaultStartY + 2, {
          align: "justify",
          maxWidth: 104,
        });

        pdf.rect(40, defaultStartY + 13, 50, 10);
        pdf.setFont("helvetica", "italic");
        pdf.text("Customer Signature", 55, defaultStartY + 22);
        pdf.setFont("helvetica", "normal");
      }
    },
  });

  const pageCount = pdf.internal.getNumberOfPages();
  const pageSize = pdf.internal.pageSize;
  const paginationX = pdf.internal.pageSize.width / 2 - 7;
  const paginationY =
    (pageSize.height ? pageSize.height : pageSize.getHeight()) - 10;

  for (var i = 1; i <= pageCount; i++) {
    pdf.setPage(i);
    pdf.text(`Page ${i} of ${pageCount}`, paginationX, paginationY);
  }

  const pdfOutput = pdf.output("blob");
  const pdfFile = new File([pdfOutput], `invoice#${invoice.order_id}.pdf`, {
    type: "application/pdf",
  });

  return pdfFile;
};

export const orderItemsCellExtra = (row, column, inline = false) => {
  // todo: try to change pre define variables for conditions like displaySubs so it looks cleaner
  let output = [<></>];

  if (column.id.includes("total") && row.taxable) {
    output = [output, <i> (T)</i>];
  }

  if (column.id.includes("total") && row.overrides) {
    output = [
      output,
      <Tooltip title="Item has overrides">
        <AutoAwesomeIcon color="info" fontSize="small" />
      </Tooltip>,
    ];
  }

  if (
    column.id === "name" &&
    +row["subitem_weight_lbs"] &&
    row["subitem_weight_lbs"] !== null
  ) {
    output = [
      output,
      <>
        <b>{` (${row["subitem_weight_lbs"]} lbs)`}</b>
        <br />
        {row["subitem_weights"].u.length && row["subitem_weights"].c.length ? (
          <>
            (U) Weight:
            {row["subitem_weights"].u.map((sItem, sIndex) => (
              <Fragment
                key={`extra-column-${column.id}-row-${row.id}-weight-u-${sIndex}`}
              >
                {sIndex === 0
                  ? ` ${sItem}`
                  : sIndex === row["subitem_weights"].u.length
                    ? ` ${sItem}`
                    : `, ${sItem}`}
                {row["subitem_lot_codes"].u[sIndex]
                  ? ` (lot ${row.subitem_lot_codes.u[sIndex]})`
                  : ""}
              </Fragment>
            ))}
            <br />
            (C) Weight:
            {row["subitem_weights"].c.map((sItem, sIndex) => (
              <Fragment
                key={`extra-column-${column.id}-row-${row.id}-weight-c-${sIndex}`}
              >
                {sIndex === 0
                  ? ` ${sItem}`
                  : sIndex === row["subitem_weights"].c.length
                    ? ` ${sItem}`
                    : `, ${sItem}`}
                {row["subitem_lot_codes"].c[sIndex]
                  ? ` (lot ${row.subitem_lot_codes.c[sIndex]})`
                  : ""}
              </Fragment>
            ))}
          </>
        ) : row["subitem_weights"].u.length ? (
          <>
            Weight:
            {row["subitem_weights"].u.map((sItem, sIndex) => (
              <Fragment
                key={`extra-column-${column.id}-row-${row.id}-weight-u-${sIndex}`}
              >
                {sIndex === 0
                  ? ` ${sItem}`
                  : sIndex === row["subitem_weights"].u.length
                    ? ` ${sItem}`
                    : `, ${sItem}`}
                {row["subitem_lot_codes"].u[sIndex]
                  ? ` (lot ${row.subitem_lot_codes.u[sIndex]})`
                  : ""}
              </Fragment>
            ))}
          </>
        ) : row["subitem_weights"].c.length ? (
          <>
            Weight:
            {row["subitem_weights"].c.map((sItem, sIndex) => (
              <Fragment
                key={`extra-column-${column.id}-row-${row.id}-weight-c-${sIndex}`}
              >
                {sIndex === 0
                  ? ` ${sItem}`
                  : sIndex === row["subitem_weights"].c.length
                    ? ` ${sItem}`
                    : `, ${sItem}`}
                {row["subitem_lot_codes"].c[sIndex]
                  ? ` (lot ${row.subitem_lot_codes.c[sIndex]})`
                  : ""}
              </Fragment>
            ))}
          </>
        ) : (
          <>{row["catch_weight_lbs"]}</>
        )}
      </>,
    ];
  } else {
    output = [
      output,
      <>
        {column.id === "name" &&
        row.subitem_lot_codes.hasOwnProperty("u") &&
        row.subitem_lot_codes.hasOwnProperty("c") ? (
          row.subitem_lot_codes.u.length && row.subitem_lot_codes.c.length ? (
            <>
              <br />
              (U) Lots:
              {Object.keys(row.subitem_lot_codes_counts.u).map(
                (sItem, sIndex) => (
                  <Fragment
                    key={`extra-column-${column.id}-row-${row.id}-lot-u-${sIndex}`}
                  >
                    {` ${sItem}${
                      row.subitem_lot_codes_counts.u[sItem] > 1
                        ? " x" + row.subitem_lot_codes_counts.u[sItem]
                        : ""
                    }${
                      sIndex + 1 ===
                      Object.keys(row.subitem_lot_codes_counts.u).length
                        ? ""
                        : ","
                    }`}
                  </Fragment>
                ),
              )}
              <br />
              (C) Lots:
              {Object.keys(row.subitem_lot_codes_counts.c).map(
                (sItem, sIndex) => (
                  <Fragment
                    key={`extra-column-${column.id}-row-${row.id}-lot-c-${sIndex}`}
                  >
                    {` ${sItem}${
                      row.subitem_lot_codes_counts.c[sItem] > 1
                        ? " x" + row.subitem_lot_codes_counts.c[sItem]
                        : ""
                    }${
                      sIndex + 1 ===
                      Object.keys(row.subitem_lot_codes_counts.c).length
                        ? ""
                        : ","
                    }`}
                  </Fragment>
                ),
              )}
            </>
          ) : row.subitem_lot_codes.u.length ? (
            <>
              <br />
              Lots:
              {Object.keys(row.subitem_lot_codes_counts.u).map(
                (sItem, sIndex) => (
                  <Fragment
                    key={`extra-column-${column.id}-row-${row.id}-lot-u-${sIndex}`}
                  >
                    {` ${sItem}${
                      row.subitem_lot_codes_counts.u[sItem] > 1
                        ? " x" + row.subitem_lot_codes_counts.u[sItem]
                        : ""
                    }
                    ${
                      sIndex + 1 ===
                      Object.keys(row.subitem_lot_codes_counts.u).length
                        ? ""
                        : ","
                    }
                    `}
                  </Fragment>
                ),
              )}
            </>
          ) : row.subitem_lot_codes.c.length ? (
            <>
              <br />
              Lots:
              {Object.keys(row.subitem_lot_codes_counts.c).map(
                (sItem, sIndex) => (
                  <Fragment
                    key={`extra-column-${column.id}-row-${row.id}-lot-c-${sIndex}`}
                  >
                    {` ${sItem}${
                      row.subitem_lot_codes_counts.c[sItem] > 1
                        ? " x" + row.subitem_lot_codes_counts.c[sItem]
                        : ""
                    }
                    ${
                      sIndex + 1 ===
                      Object.keys(row.subitem_lot_codes_counts.c).length
                        ? ""
                        : ","
                    }
                    `}
                  </Fragment>
                ),
              )}
            </>
          ) : (
            <></>
          )
        ) : (
          <></>
        )}
      </>,
    ];
  }

  if (
    row["surcharges"].length &&
    ["name", "case_price", "total"].includes(column.id)
  ) {
    output = [
      output,
      <>
        {row["surcharges"].map((surcharge, surchIndex) => (
          <Fragment
            key={`column-${column.id}-row-${row.id}-surcharge-${surchIndex}`}
          >
            {column.id === "name" ? (
              <>
                <br />
                <div
                  style={{
                    textAlign: "center",
                  }}
                >
                  <i>{surcharge.name}</i>
                </div>
              </>
            ) : column.id === "case_price" ? (
              <>
                {row.case_price !== null ? (
                  <br />
                ) : (
                  <div style={{ height: 40 }} />
                )}
                <div
                  style={{
                    textAlign: "right",
                  }}
                >
                  <i>
                    $
                    {surcharge.invoice_override_price !== null
                      ? surcharge.invoice_override_price.toFixed(2)
                      : surcharge.unit_price.toFixed(2)}
                  </i>
                </div>
              </>
            ) : column.id === "total" ? (
              <>
                <br />
                <div
                  style={{
                    textAlign: "right",
                  }}
                >
                  <i>
                    $
                    {surcharge.invoice_override_total !== null
                      ? surcharge.invoice_override_total.toFixed(2)
                      : surcharge.unit_price.toFixed(2)}
                  </i>
                </div>
              </>
            ) : (
              <></>
            )}
          </Fragment>
        ))}
      </>,
    ];
  }

  if (inline) {
    let outputInline = output?.length
      ? output.reduce((prev, curr) => prev + renderToString(curr), "")
      : "";

    outputInline = outputInline
      .replaceAll("<br/>", `\n`)
      .replaceAll(`<br data-reactroot=""/>`, `\n`)
      .replace(/<[^>]*>/g, "");

    return outputInline;
  }

  return output;
};

export const getInvoice = async (orderId) =>
  await backend
    .get(`${API_URL}orders/${orderId}/invoice`)
    .then(({ data }) => {
      let dataItemsMap = [];
      let invoiceOverrides = false;

      const iofDefault = {
        credit_card_fee: data.credit_card_fee,
        refrigerated_delivery_fee: data.refrigerated_delivery_fee,
        late_fee: data.late_fee,
        fuel_surcharge: data.fuel_surcharge,
      };

      if (data.items.length) {
        dataItemsMap = data.items.map((item) => {
          const ofDefault = {
            unit_price: item.invoice_override_unit_price,
            case_price: item.invoice_override_case_price,
            total: item.invoice_override_total,
            invoice_override_unit_price: item.invoice_override_unit_price,
            invoice_override_case_price: item.invoice_override_case_price,
            invoice_override_total: item.invoice_override_total,
            surcharges: item.surcharges,
          };

          let overrides =
            item.invoice_override_unit_price !== null ||
            item.invoice_override_case_price !== null ||
            item.invoice_override_total !== null;

          if (!overrides) {
            overrides = item.surcharges.some(
              (sItem) =>
                sItem.invoice_override_price !== null ||
                sItem.invoice_override_total !== null,
            );
          }

          if (!invoiceOverrides && overrides) {
            invoiceOverrides = true;
          }

          let slc_counts = null;

          if (
            item.subitem_lot_codes.hasOwnProperty("u") ||
            item.subitem_lot_codes.hasOwnProperty("c")
          ) {
            slc_counts = { u: {}, c: {} };

            item.subitem_lot_codes.u.forEach((lotItem) => {
              slc_counts.u[lotItem] = slc_counts.u[lotItem]
                ? slc_counts.u[lotItem] + 1
                : 1;
            });

            item.subitem_lot_codes.c.forEach((lotItem) => {
              slc_counts.c[lotItem] = slc_counts?.c[lotItem]
                ? slc_counts.c[lotItem] + 1
                : 1;
            });
          }

          item.subitem_lot_codes_counts = slc_counts;

          if (
            item.subitem_weights.hasOwnProperty("u") ||
            item.subitem_weights.hasOwnProperty("c")
          ) {
            let totalWeightLbs = 0;
            let totalUWeightLbs = 0;
            let totalCWeightLbs = 0;

            // sum unit weights
            item.subitem_weights.u.forEach((weight) => {
              totalWeightLbs += weight;
              totalUWeightLbs += weight;
            });

            // sum case weights
            item.subitem_weights.c.forEach((weight) => {
              totalWeightLbs += weight;
              totalCWeightLbs += weight;
            });

            return {
              ...item,
              subitem_weight_lbs: totalWeightLbs.toFixed(2),
              subitem_u_weight_lbs: totalUWeightLbs.toFixed(2),
              subitem_c_weight_lbs: totalCWeightLbs.toFixed(2),
              of_default_values: ofDefault,
              overrides: overrides,
            };
          } else {
            return {
              ...item,
              subitem_weight_lbs: null,
              subitem_u_weight_lbs: null,
              subitem_c_weight_lbs: null,
              of_default_values: ofDefault,
              overrides: overrides,
            };
          }
        });
      }

      return Promise.resolve({
        ...data,
        items: dataItemsMap,
        of_default_values: iofDefault,
        payable: data.paid_status === "r" ? true : false,
        hasOverrides: invoiceOverrides,
      });
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });

const Invoice = (props) => {
  const orderId = props.match.params.id;

  const classes = useStyles();
  const theme = useTheme();

  const appearance = {
    theme: "stripe",
  };

  const loader = "auto";

  const currentUserStore = useSelector((state) => state.current_user);

  const [invoice, setInvoice] = useState(null);
  const [invoiceShared, setInvoiceShared] = useState(false);
  const [invoiceShareModal, setInvoiceShareModal] = useState(false);
  const [isInvoiceSharing, setIsInvoiceSharing] = useState(false);
  const [email, setEmail] = useState("");
  const [toEmail, setToEmail] = useState("");
  const [emailList, setEmailList] = useState([]);
  const [customSubject, setCustomSubject] = useState("");
  const [note, setNote] = useState("");
  const [errorInfo, setErrorInfo] = useState({ error: false, message: "" });
  const [overridden, setOverridden] = useState(false);
  const [loadingFlag, setLoadingFlag] = useState(false);
  const [finishedFlag, setFinishedFlag] = useState(false);
  const [regenerateInvoiceModal, setRegenerateInvoiceModal] = useState(false);
  const [confirmOverrideModal, setConfirmOverrideModal] = useState(false);
  const [overriddenDirty, setOverriddenDirty] = useState(false);
  const [hasOverrides, setHasOverrides] = useState(false);
  const [action, setAction] = useState(false); // 1 = save, 2 = discard, 3 = reset, false = save no actions
  const [paymentModal, setPaymentModal] = useState(false);
  const [paymentData, setPaymentData] = useState(null);
  const [paymentIntent, setPaymentIntent] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [paymentSummary, setPaymentSummary] = useState(null);
  const [paymentDetails, setPaymentDetails] = useState([]);
  const [paymentDetailsModal, setPaymentDetailsModal] = useState(false);
  const [userCanPay, setUserCanPay] = useState(false);
  const [finalizeInvoice, setFinalizeInvoice] = useState(false);
  const [finalizeInvoiceModal, setFinalizeInvoiceModal] = useState(false);

  const [credits, setCredits] = useState([]);
  const [creditsOpen, setCreditsOpen] = useState(false);
  const [creditsDirty, setCreditsDirty] = useState(false);
  const [creditsLoading, setCreditsLoading] = useState(false);
  const [creditsError, setCreditsError] = useState(null);
  const searchTimers = useRef({});

  useEffect(() => {
    const getInvoicePaymentDetails = async () => {
      await backend
        .get(`${API_URL}orders/${orderId}/invoice/paymentdetails`)
        .then(({ data }) => {
          setPaymentDetails(data);
        });
    };

    const getInvoiceData = async () => await getInvoice(orderId);

    if (!isNaN(orderId) && currentUserStore) {
      getInvoiceData()
        .then((data) => {
          if (!["", "r"].includes(data.paid_status)) {
            getInvoicePaymentDetails();
          }

          if (data.customer.email !== "") {
            setEmailList([data.customer.email]);
          }

          // todo: include invoice fees (credit card fee, refrigerated fee, etc) in the hasOverrides logic
          // there might be fees overrides with no items overrides, this needs to be added on backend as well
          //
          // update 21/01: there is no control from fees overrides on backend so its not needed

          const localUser = JSON.parse(localStorage.user);

          setInvoice(data);
          setFinalizeInvoice(["c", "x"].includes(data?.paid_status));
          setHasOverrides(data.hasOverrides);
          const loadedCredits = data.credits || [];

          const loadedCreditsMap = loadedCredits.map((c) => ({
            ...c,
            product_mode: Boolean(c.product),
            unit_type: c.product_data ? c.product_data.unit_type : null,
            item_code: c.product_data
              ? c.product_data.item_code?.item_code || ""
              : "",
            _productInput: c.product_data?.name || c.description || "",
            _productOptions: c.product_data ? [c.product_data] : [],
            _delete: false,
          }));

          setCredits(loadedCreditsMap);
          setCreditsOpen(loadedCreditsMap.length > 0);
          setToEmail(data.customer.email);
          setUserCanPay(
            () =>
              currentUserStore.username === localUser.user.username &&
              localUser.user.can_see_payments_column,
          );
        })
        .catch((error) => {
          console.log(error);
          const errorData = error.response.data;

          setErrorInfo({
            error: true,
            message:
              typeof errorData === "object"
                ? errorData.hasOwnProperty("message")
                  ? errorData.message
                  : errorData.detail
                : error.message,
          });
        });
    }
  }, [orderId, currentUserStore]);

  const handleAddCredit = () => {
    setCredits((prev) => [
      ...prev,
      {
        id: null,
        product: null,
        description: "",
        unit_quantity: "",
        case_quantity: "",
        unit_price: null,
        case_price: null,
        total: "",
        unit_type: null,
        item_code: "",
        product_mode: true,
        _productInput: "",
        _productOptions: [],
        _delete: false,
      },
    ]);
    setCreditsDirty(true);
  };

  const handleCreditChange = (index, field, value) => {
    setCredits((prev) =>
      prev.map((c, i) => {
        if (i !== index) return c;
        const updated = { ...c, [field]: value };
        if (
          c.product_mode &&
          [
            "unit_quantity",
            "case_quantity",
            "unit_price",
            "case_price",
          ].includes(field)
        ) {
          updated.total =
            (updated.unit_quantity || 0) * (updated.unit_price || 0) +
            (updated.case_quantity || 0) * (updated.case_price || 0);
        }

        if (field === "total") {
          if (c.unit_quantity > 0 && c.case_quantity > 0) return updated;

          if (c.unit_quantity > 0) {
            updated.unit_price = c.unit_quantity
              ? value / c.unit_quantity
              : null;
          } else if (c.case_quantity > 0) {
            updated.case_price = c.case_quantity
              ? value / c.case_quantity
              : null;
          }
        }

        return updated;
      }),
    );
    setCreditsDirty(true);
  };

  const handleCreditDelete = (index) => {
    setCredits((prev) =>
      prev
        .map((c, i) => {
          if (i !== index) return c;
          return c.id ? { ...c, _delete: true } : null;
        })
        .filter(Boolean),
    );
    setCreditsDirty(true);
  };

  const handleCreditModeToggle = (index) => {
    setCredits((prev) =>
      prev.map((c, i) => {
        if (i !== index) return c;
        if (c.product_mode) {
          return {
            ...c,
            product_mode: false,
            product: null,
            unit_price: null,
            case_price: null,
            unit_quantity: "",
            case_quantity: "",
            unit_type: null,
            item_code: "",
            _productInput: "",
            _productOptions: [],
          };
        }
        return {
          ...c,
          product_mode: true,
          _productInput: "",
          _productOptions: [],
        };
      }),
    );
  };

  const handleCreditProductSelect = (index, product) => {
    if (!product) return;
    setCredits((prev) =>
      prev.map((c, i) => {
        if (i !== index) return c;
        return {
          ...c,
          product: product.upc,
          description: product.name,
          unit_price: product.display_unit_price || null,
          case_price: product.display_case_price || null,
          unit_type: product.unit_type,
          item_code: product.item_code?.item_code || "",
          _productInput: product.name,
          total: "",
          unit_quantity: "",
          case_quantity: "",
          product_data: product,
        };
      }),
    );
    setCreditsDirty(true);
  };

  const handleCreditProductInputChange = (index, value, reason) => {
    if (value === "" && reason === "reset") return;
    setCredits((prev) =>
      prev.map((c, i) =>
        i === index
          ? {
              ...c,
              _productInput: value,
              _productOptions: value.length < 3 ? [] : c._productOptions,
            }
          : c,
      ),
    );
    if (searchTimers.current[index]) clearTimeout(searchTimers.current[index]);
    if (value.length >= 3) {
      searchTimers.current[index] = setTimeout(async () => {
        const companyLocationId = invoice?.company_location_id;
        const url = `${API_URL}products?no_page=1&search=${encodeURIComponent(
          value,
        )}${companyLocationId ? `&company_location=${companyLocationId}` : ""}`;
        await backend
          .get(url)
          .then(({ data }) => {
            const results = Array.isArray(data) ? data : data.results || [];
            setCredits((prev) =>
              prev.map((c, i) =>
                i === index ? { ...c, _productOptions: results } : c,
              ),
            );
          })
          .catch(console.log);
      }, 400);
    }
  };

  const handleSaveCredits = async () => {
    setCreditsLoading(true);
    setCreditsError(null);

    const buildPayload = (c) => ({
      product: c.product,
      description: c.description,
      unit_quantity: c.unit_quantity !== "" ? +c.unit_quantity : null,
      case_quantity: c.case_quantity !== "" ? +c.case_quantity : null,
      unit_price: c.unit_price,
      case_price: c.case_price,
      total: +c.total,
      invoice_reference: c.invoice_reference
        ? c.invoice_reference
        : invoice.order_id,
      reason: c.reason,
    });

    try {
      await Promise.all([
        ...credits
          .filter((c) => c._delete && c.id)
          .map((c) =>
            backend.delete(
              `${API_URL}orders/${orderId}/invoice/credits/${c.id}`,
            ),
          ),
        ...credits
          .filter((c) => !c._delete && c.id)
          .map((c) =>
            backend.patch(
              `${API_URL}orders/${orderId}/invoice/credits/${c.id}`,
              buildPayload(c),
            ),
          ),
        ...credits
          .filter((c) => !c._delete && !c.id)
          .map((c) =>
            backend.post(
              `${API_URL}orders/${orderId}/invoice/credits`,
              buildPayload(c),
            ),
          ),
      ]);
      setCreditsLoading(false);
      setCreditsDirty(false);
      window.location.reload();
    } catch (error) {
      console.log(error);
      const errorData = error.response?.data;
      setCreditsError(
        typeof errorData === "object"
          ? errorData.hasOwnProperty("message")
            ? errorData.message
            : errorData.detail
          : error.message,
      );
      setCreditsLoading(false);
    }
  };

  const creditsTotal = credits
    .filter((c) => !c._delete)
    .reduce((sum, c) => sum + (parseFloat(c.total) || 0), 0);

  const creditsSubtotal =
    (invoice?.grand_total || 0) + Math.abs(invoice?.credit_total || 0);

  const creditsOverflow = creditsSubtotal - creditsTotal < 0;

  const overriddenEndorment = (name, item) => {
    const [field, , , surchIndex] = name.split("-");

    let defaultVal = item[field];
    let currentVal = item[`invoice_override_${field}`];

    if (name === "fuel_surcharge" || name.includes("_fee")) {
      currentVal = item.of_default_values[field];
    } else if (name.includes("surcharge")) {
      const surchDeffield = field === "total" ? "total" : "unit_price";
      const surchCurfield =
        field === "total" ? "invoice_override_total" : "invoice_override_price";

      defaultVal = item.surcharges[surchIndex][surchDeffield];
      currentVal = item.surcharges[surchIndex][surchCurfield];
    }

    if (currentVal !== null && defaultVal !== currentVal) {
      return (
        <InputAdornment position="end">
          <IconButton
            aria-label="reset overridden value"
            onClick={() =>
              handleChange({
                target: { name: name, value: "_reset_overridden" },
              })
            }
          >
            <RestartAltIcon />
          </IconButton>
        </InputAdornment>
      );
    }

    return <></>;
  };

  const overriddenStyle = (name, item) => {
    const [field, , , surchIndex] = name.split("-");

    let defaultVal = item[field];
    let currentVal = item[`invoice_override_${field}`];

    if (name === "fuel_surcharge" || name.includes("_fee")) {
      currentVal = item.of_default_values[field];
    } else if (name.includes("surcharge")) {
      const surchDeffield = field === "total" ? "total" : "unit_price";
      const surchCurfield = field === "total" ? "total" : "price";

      defaultVal = item.surcharges[surchIndex][surchDeffield];
      currentVal =
        item.surcharges[surchIndex][`invoice_override_${surchCurfield}`];
    }

    if (currentVal !== null && defaultVal !== currentVal) return "lightblue";

    return "inherit";
  };

  const handleChange = (e) => {
    const { checked, name, value } = e.target;

    const [field, rowIndex, , surchIndex] = name.split("-");

    if (!hasOverrides && field !== "payable") {
      setHasOverrides(true);
    }

    // todo: add logic to affect credit changes

    setInvoice((prevState) => {
      if (["unit_price", "case_price", "total"].includes(field)) {
        let subtotalNew = 0;
        let totalNew = 0;

        const itemsMap = prevState.items.map((item, itemIndex) => {
          if (itemIndex !== +rowIndex) {
            subtotalNew +=
              item.invoice_override_total !== null
                ? item.invoice_override_total
                : item.total;

            return item;
          }

          if (name.includes("surcharge")) {
            // todo: check surcharge total sums
            let totalSurcharges = 0;

            const surchargesMap = item.surcharges.map((sItem, sIndex) => {
              if (sIndex !== +surchIndex) {
                totalSurcharges += sItem.total;

                return sItem;
              }

              const fieldName = field === "total" ? "total" : "price";
              const fieldDefName = field === "total" ? "total" : "unit_price";

              const fieldValue =
                value === "_reset_overridden"
                  ? item.surcharges[sIndex][fieldDefName]
                  : +value;

              let sItemObj = {
                ...sItem,
                [`invoice_override_${fieldName}`]: fieldValue,
              };

              if (fieldName === "total") {
                sItemObj["invoice_override_unit_price"] = +(
                  fieldValue / sItemObj.quantity
                ).toFixed(2);
              } else {
                sItemObj["invoice_override_total"] = +(
                  fieldValue * sItemObj.quantity
                ).toFixed(2);
              }

              totalSurcharges +=
                sItemObj.invoice_override_total !== null
                  ? sItemObj.invoice_override_total
                  : sItemObj.total;

              sItemObj.modified = true;

              if (!overriddenDirty) setOverriddenDirty(true);

              return sItemObj;
            });

            const itemTotal =
              item.invoice_override_total !== null
                ? item.invoice_override_total
                : item.total;

            subtotalNew += itemTotal + totalSurcharges;

            return { ...item, surcharges: surchargesMap, modified: true };
          } else {
            const unitType = item.unit_quantity > 0 ? "unit" : "case";
            const bothTypes = item.unit_quantity > 0 && item.case_quantity > 0;

            const fieldValue =
              value === "_reset_overridden" ? item[field] : +value;

            let itemObj = {
              ...item,
              [`invoice_override_${field}`]: fieldValue,
            };

            const qtyType = itemObj.weighable
              ? +itemObj.subitem_weight_lbs
              : itemObj[`${unitType}_quantity`];

            if (field === "total") {
              itemObj[`invoice_override_${unitType}_price`] = +(
                fieldValue / qtyType
              ).toFixed(2);
            } else if (bothTypes) {
              const fieldUnit =
                itemObj["invoice_override_unit_price"] !== null
                  ? "invoice_override_unit_price"
                  : "unit_price";
              const fieldCase =
                itemObj["invoice_override_case_price"] !== null
                  ? "invoice_override_case_price"
                  : "case_price";

              const qtyUnit = itemObj.weighable
                ? +itemObj.subitem_u_weight_lbs
                : itemObj["unit_quantity"];

              const qtyCase = itemObj.weighable
                ? +itemObj.subitem_c_weight_lbs
                : itemObj["case_quantity"];

              itemObj["invoice_override_total"] = +(
                itemObj[fieldUnit] * qtyUnit +
                itemObj[fieldCase] * qtyCase
              ).toFixed(2);
            } else {
              itemObj["invoice_override_total"] = +(
                fieldValue * qtyType
              ).toFixed(2);
            }

            subtotalNew +=
              itemObj["invoice_override_total"] !== null
                ? itemObj["invoice_override_total"]
                : itemObj.total;

            itemObj.modified = true;

            if (!overriddenDirty) setOverriddenDirty(true);

            return itemObj;
          }
        });

        totalNew += subtotalNew;

        if (prevState.credit_card_fee) {
          totalNew += prevState.credit_card_fee;
        }

        if (prevState.refrigerated_delivery_fee) {
          totalNew += prevState.refrigerated_delivery_fee;
        }

        if (prevState.late_fee) {
          totalNew += prevState.late_fee;
        }

        if (prevState.tax_total) {
          totalNew += prevState.tax_total;
        }

        return {
          ...prevState,
          items: itemsMap,
          subtotal: +subtotalNew.toFixed(2),
          grand_total: +totalNew.toFixed(2),
        };
      } else if (field === "payable") {
        let invoiceObj = {
          ...prevState,
          [field]: checked,
        };

        return invoiceObj;
      } else {
        const fieldValue =
          value === "_reset_overridden"
            ? prevState.of_default_values[field]
            : +value;

        let totalNew = prevState.grand_total - prevState[field] + fieldValue;

        let invoiceObj = {
          ...prevState,
          [field]: fieldValue,
          grand_total: +totalNew.toFixed(2),
        };

        if (!overriddenDirty) setOverriddenDirty(true);

        return invoiceObj;
      }
    });
  };

  const orderItemsCellValue = (row, column, rowIndex) => {
    let value = row[column.id];

    if (typeof value === "boolean") {
      return "" + value;
    }

    if (
      (column.id === "unit_quantity" && value === 0) ||
      (column.id === "case_quantity" && value === 0)
    ) {
      value = "";
    }

    if (
      (column.id.includes("price") || column.id.includes("total")) &&
      row[`invoice_override_${column.id}`] !== null
    ) {
      value = row[`invoice_override_${column.id}`];
    }

    if (
      (column.id.includes("price") || column.id.includes("total")) &&
      value !== null
    ) {
      value =
        "$" +
        value.toFixed(2) +
        `${
          column.id.includes("price") && row["subitem_weight_lbs"] > 0
            ? " / lb"
            : ""
        }`;
    }

    if (
      overridden &&
      (column.id.includes("price") || column.id.includes("total"))
    ) {
      value = (
        <TextField
          fullWidth
          InputProps={{
            inputProps: {
              autoComplete: "off",
              step: "0.01",
            },
            endAdornment: overriddenEndorment(`${column.id}-${rowIndex}`, row),
          }}
          size="small"
          variant="outlined"
          type="number"
          label={column.label}
          name={`${column.id}-${rowIndex}`}
          value={
            (row[`invoice_override_${column.id}`] !== null
              ? row[`invoice_override_${column.id}`]
              : row[column.id]) || 0
          }
          onChange={handleChange}
          style={{
            background: overriddenStyle(`${column.id}-${rowIndex}`, row),
          }}
          disabled={
            column.id.includes("total") &&
            row.unit_quantity > 0 &&
            row.case_quantity > 0
          }
        />
      );
    }

    if (
      (column.id === "unit_price" && row["unit_quantity"] === 0) ||
      (column.id === "case_price" && row["case_quantity"] === 0)
    ) {
      value = "";
    }

    return value;
  };

  const toggleFinalizeInvoiceModal = () => {
    setLoadingFlag(false);
    setErrorInfo({ error: false, message: "" });
    setFinalizeInvoiceModal(!finalizeInvoiceModal);
  };

  const finalizeInvoiceModalContent = (
    <div className={classes.modal}>
      {!loadingFlag && !finishedFlag ? (
        <>
          Are you sure you want to finalize this invoice?
          <br />
          <br />
          The customer will be charged for the invoice total
          <br />
          <br />
          <div align="right">
            <Button
              onClick={() => toggleFinalizeInvoiceModal()}
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={() => handleFinalizeInvoice()}
              className={classes.button}
              color="primary"
            >
              Confirm
            </Button>
          </div>
        </>
      ) : loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>
              {`Finalizing invoice`}
              <br />
            </div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              {`There was an error while finalizing the invoice`}
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "auto",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {errorInfo.message}
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => toggleFinalizeInvoiceModal()}
                  className={classes.button}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          The invoice was finalized successfully.
          <div align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => toggleFinalizeInvoiceModal()}
              className={classes.button}
            >
              Continue
            </Button>
          </div>
        </>
      )}
    </div>
  );

  const handleFinalizeInvoice = async () => {
    setLoadingFlag(true);

    await backend
      .post(`${API_URL}orders/${invoice.order_id}/invoice/codpaymentfinalize`)
      .then(({ data }) => {
        if (data?.invoice?.order_id) {
          setInvoice(data.invoice);
        }

        setFinalizeInvoice(true);
        setLoadingFlag(false);
        setFinishedFlag(true);
      })
      .catch((error) => {
        console.log(error);

        setErrorInfo({
          error: true,
          message:
            error.response?.data?.detail ||
            error.response?.data?.message ||
            "An error occurred while finalizing the invoice. Please try again.",
        });
      });
  };

  const handleChangeSharing = (e) => {
    const { name, value } = e.target;

    switch (name) {
      case "email":
        setEmail(value);
        break;
      case "to_email":
        setToEmail(value);
        break;
      case "custom_subject":
        setCustomSubject(value);
        break;
      case "note":
        setNote(value);
        break;
      default:
        break;
    }
  };

  const handleClickAddEmail = () => {
    setEmailList([...emailList, email]);
    setEmail("");
  };

  const handleClickDeleteEmail = (idx) => {
    const emailListData = [].concat(emailList);
    const emailIndex = idx.replace("email-", "");

    emailListData.splice(+emailIndex, 1);

    setEmailList(emailListData);
  };

  const toggleInvoiceShareModal = () =>
    setInvoiceShareModal(!invoiceShareModal);

  const resetInvoiceShare = () => {
    setInvoiceShareModal(!invoiceShareModal);
    setInvoiceShared(false);
  };

  const invoiceShareContent = (
    <div className={classes.modal}>
      {invoiceShared ? (
        <>
          <div align="center">
            The invoice has been shared through email successfully.
          </div>
          <div align="right">
            <Button
              onClick={() => resetInvoiceShare()}
              className={classes.button}
            >
              Continue
            </Button>
          </div>
        </>
      ) : !isInvoiceSharing ? (
        <>
          Please add an email to share the invoice with:
          <br />
          <Grid container spacing={0} style={{ alignItems: "center" }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                id="outlined-basic"
                variant="outlined"
                label="Email To"
                name="to_email"
                value={toEmail}
                onChange={handleChangeSharing}
              />
            </Grid>
            <Grid item xs={12}>
              <br />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                id="outlined-basic"
                variant="outlined"
                label="Custom Subject"
                name="custom_subject"
                value={customSubject}
                onChange={handleChangeSharing}
              />
            </Grid>
            <Grid item xs={12}>
              <br />
              You can also add up to 4 additional emails:
              <br />
            </Grid>
            <Grid item xs={true}>
              <TextField
                fullWidth
                size="small"
                id="outlined-basic"
                variant="outlined"
                label="Email CC"
                name="email"
                value={email}
                onChange={handleChangeSharing}
              />
            </Grid>
            <Grid item xs={"auto"}>
              <Button
                style={{ marginLeft: 8 }}
                variant="contained"
                color="primary"
                onClick={handleClickAddEmail}
                disabled={
                  !email.includes("@") ||
                  !email.includes(".") ||
                  emailList.length >= 5
                }
              >
                Add
              </Button>
            </Grid>
            <Grid item xs={12}></Grid>
            {emailList.length ? (
              <>
                {emailList.map((email, idx) =>
                  email !== "" ? (
                    <Fragment key={`email-${idx}`}>
                      <Grid item xs={true}>
                        {email}
                      </Grid>
                      <Grid item xs={"auto"}>
                        <Tooltip title="Delete">
                          <IconButton
                            aria-label="delete"
                            onClick={() =>
                              handleClickDeleteEmail(`email-${idx}`)
                            }
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                      <Grid item xs={12}></Grid>
                    </Fragment>
                  ) : (
                    <Fragment key={`email-${idx}`}></Fragment>
                  ),
                )}
                <br />
              </>
            ) : (
              <>
                <br />
              </>
            )}
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                size="small"
                id="outlined-basic"
                variant="outlined"
                label="Note"
                name="note"
                value={note}
                onChange={handleChangeSharing}
              />
            </Grid>
          </Grid>
          <br />
          <div align="right">
            <Button
              onClick={() => toggleInvoiceShareModal()}
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => invoiceShareSend()}
              className={classes.button}
              disabled={!toEmail.includes("@") || !toEmail.includes(".")}
            >
              Send
            </Button>
          </div>
        </>
      ) : (
        <>
          <div align="center">
            <CircularProgress />
            <br />
            <br />
            Generating PDF and sharing the invoice
            <br />
            <br />
            Please do not leave this page until this pop up is closed
            automatically
          </div>
        </>
      )}
    </div>
  );

  const invoiceShareSend = async () => {
    setIsInvoiceSharing(true);
    const pdfFile = generateDocument(invoice);

    let invoiceFormData = new FormData();

    invoiceFormData.append("file", pdfFile);
    invoiceFormData.append("to_email", toEmail);

    emailList.forEach((item, index) => {
      invoiceFormData.append(`additional_emails[${index}]`, item);
    });

    if (customSubject !== "") {
      invoiceFormData.append("custom_subject", customSubject);
    }

    if (note !== "") {
      invoiceFormData.append("note", note);
    }

    await backend
      .post(`${API_URL}orders/${orderId}/invoice/email`, invoiceFormData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(({ data }) => {
        setInvoiceShared(true);
      });
  };

  const toggleRegenerateInvoiceModal = () =>
    setRegenerateInvoiceModal(!regenerateInvoiceModal);

  const dismissRegenerateInvoiceModal = (redirect = false) => {
    setLoadingFlag(false);
    setFinishedFlag(false);
    toggleRegenerateInvoiceModal();
  };

  const regenerateInvoiceModalContent = (
    <div className={classes.modal}>
      {!loadingFlag && !finishedFlag ? (
        <>
          Regenerate the invoice?
          <br />
          <br />
          This will delete the existing invoice and any price overrides and
          recreate the invoice based on the current order data.
          <br />
          <br />
          <Stack spacing={2} direction="row" justifyContent="right">
            <Button onClick={() => dismissRegenerateInvoiceModal()}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="success"
              onClick={() => sendRegenerateInvoiceRequest()}
            >
              Continue
            </Button>
          </Stack>
        </>
      ) : loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>
              {`Generating invoice`}
              <br />
              This may take some time relative to the orderitems
            </div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              {`There was an error while generating the invoice`}
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {errorInfo.message}
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => dismissRegenerateInvoiceModal()}
                  className={classes.button}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          The successfully was generated successfully.
          <div align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => dismissRegenerateInvoiceModal()}
              className={classes.button}
            >
              Continue
            </Button>
          </div>
        </>
      )}
    </div>
  );

  const sendRegenerateInvoiceRequest = async () => {
    setLoadingFlag(true);

    if (orderId !== null) {
      const payloadObj = { force_regenerate: true };

      await backend
        .post(`${API_URL}orders/${orderId}/generateinvoice`, payloadObj)
        .then(({ data }) => {
          setLoadingFlag(false);
          setFinishedFlag(true);

          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
          const errorData = error.response.data;

          setErrorInfo({
            error: true,
            message:
              typeof errorData === "object"
                ? errorData.hasOwnProperty("message")
                  ? errorData.message
                  : errorData.detail
                : error.message,
          });
        });
    }
  };

  const handleClickReset = () => {
    setInvoice((prevState) => {
      let dataItemsMap = [];
      let subtotalNew = 0;
      let totalNew = 0;

      if (prevState.items.length) {
        dataItemsMap = prevState.items.map((item) => {
          let overrides = false;

          item.invoice_override_unit_price = null;
          item.invoice_override_case_price = null;
          item.invoice_override_total = null;

          subtotalNew += item.total;

          const surchargesMap = item.surcharges.map((sItem) => {
            subtotalNew += sItem.total;

            return {
              ...sItem,
              invoice_override_price: null,
              invoice_override_total: null,
            };
          });

          return {
            ...item,
            surcharges: surchargesMap,
            overrides: overrides,
          };
        });
      }

      totalNew += subtotalNew;

      if (prevState.credit_card_fee) {
        totalNew += prevState.credit_card_fee;
      }

      if (prevState.refrigerated_delivery_fee) {
        totalNew += prevState.refrigerated_delivery_fee;
      }

      if (prevState.late_fee) {
        totalNew += prevState.late_fee;
      }

      if (prevState.tax_total) {
        totalNew += prevState.tax_total;
      }

      const dataMap = {
        ...prevState,
        items: dataItemsMap,
        subtotal: +subtotalNew.toFixed(2),
        grand_total: +totalNew.toFixed(2),
      };

      setInvoice(dataMap);
    });

    setOverriddenDirty(true);
    setHasOverrides(false);
    dismissConfirmOverrideModal();
  };

  const handleClickDiscard = () => {
    let overrides = false;

    setInvoice((prevState) => {
      let dataItemsMap = [];

      if (prevState.items.length) {
        dataItemsMap = prevState.items.map((item) => {
          item.invoice_override_unit_price =
            item.of_default_values.invoice_override_unit_price !== null
              ? item.of_default_values.invoice_override_unit_price
              : null;
          item.invoice_override_case_price =
            item.of_default_values.invoice_override_case_price !== null
              ? item.of_default_values.invoice_override_case_price
              : null;
          item.invoice_override_total =
            item.of_default_values.invoice_override_total !== null
              ? item.of_default_values.invoice_override_total
              : null;

          overrides =
            item.invoice_override_unit_price !== null ||
            item.invoice_override_case_price !== null ||
            item.invoice_override_total !== null;

          if (!overrides) {
            overrides = item.surcharges.some(
              (sItem) =>
                sItem.invoice_override_price !== null ||
                sItem.invoice_override_total !== null,
            );
          }

          const surchargesMap = item.surcharges.map((sItem, sIndex) => ({
            ...sItem,
            invoice_override_price:
              item.of_default_values.surcharges[sIndex]
                .invoice_override_price !== null
                ? item.of_default_values.surcharges[sIndex]
                    .invoice_override_price
                : null,
            invoice_override_total: item.of_default_values.surcharges[sIndex]
              .invoice_override_total
              ? item.of_default_values.surcharges[sIndex].invoice_override_total
              : null,
          }));

          return {
            ...item,
            surcharges: surchargesMap,
            overrides: overrides,
          };
        });
      }

      // todo: add logic to reset fees at discard changes

      const dataMap = {
        ...prevState,
        items: dataItemsMap,
      };

      return dataMap;
    });

    setOverriddenDirty(false);
    setHasOverrides(overrides);
    dismissConfirmOverrideModal();
  };

  const toggleOverridden = () => setOverridden(!overridden);

  const toggleConfirmOverrideModal = (action = false) => {
    setAction(action);
    setConfirmOverrideModal(!confirmOverrideModal);
  };

  const dismissConfirmOverrideModal = () => {
    setLoadingFlag(false);
    setFinishedFlag(false);
    setAction(false);
    toggleConfirmOverrideModal();
  };

  const confirmOverrideModalContent = (
    <div className={classes.modal}>
      {!loadingFlag && !finishedFlag ? (
        <>
          {!action
            ? `You have unsaved changes. Save and continue?`
            : action === 1
              ? `Do you want to save price overrides?`
              : action === 2
                ? `Discard your current changes?`
                : `Reset all invoice lines to their original price? (You may save or discard this reset afterwards.)`}
          <br />
          <br />
          <Stack spacing={2} direction="row" justifyContent="right">
            <Button onClick={() => dismissConfirmOverrideModal()}>
              Cancel
            </Button>
            {!action && (
              <>
                <Button
                  variant="contained"
                  color="inherit"
                  onClick={() => {
                    handleClickDiscard();
                  }}
                  disabled={!overriddenDirty}
                >
                  Discard
                </Button>
              </>
            )}
            <Button
              variant="contained"
              color="success"
              onClick={() => {
                !action || action === 1
                  ? sendConfirmOverrideRequest()
                  : action === 2
                    ? handleClickDiscard()
                    : handleClickReset();
              }}
            >
              Continue
            </Button>
          </Stack>
        </>
      ) : loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>
              {`Saving price overrides`}
              <br />
              This may take some time relative to the orderitems
            </div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              {`There was an error while saving the price overrides`}
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {errorInfo.message}
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => dismissConfirmOverrideModal()}
                  className={classes.button}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          Your changes were saved successfully.
          <div align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => dismissConfirmOverrideModal()}
              className={classes.button}
            >
              Continue
            </Button>
          </div>
        </>
      )}
    </div>
  );

  const sendConfirmOverrideRequest = async () => {
    setLoadingFlag(false);
    setFinishedFlag(true);

    let surchargeItemsOverride = [];

    const orderItemsOverride = invoice.items
      .filter((item) => item.modified)
      .map((item) => {
        if (item.surcharges.length) {
          item.surcharges
            .filter((sItem) => sItem.modified)
            .forEach((sItem) => {
              surchargeItemsOverride.push({
                id: sItem.id,
                invoice_override_price: sItem.invoice_override_price,
                // invoice_override_total: sItem.invoice_override_total,
              });
            });
        }

        return {
          id: item.id,
          invoice_override_case_price: item.invoice_override_case_price,
          // invoice_override_total: item.invoice_override_total,
          invoice_override_unit_price: item.invoice_override_unit_price,
        };
      });

    if (orderItemsOverride.length || surchargeItemsOverride.length) {
      const payloadObj = {
        order_items: orderItemsOverride,
        surcharge_items: surchargeItemsOverride,
      };

      await backend
        .post(`${API_URL}orders/${orderId}/invoice/itemoverride`, payloadObj)
        .then(({ data }) => {
          setLoadingFlag(false);
          setFinishedFlag(true);

          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
          const errorData = error.response.data;

          setErrorInfo({
            error: true,
            message:
              typeof errorData === "object"
                ? errorData.hasOwnProperty("message")
                  ? errorData.message
                  : errorData.detail
                : error.message,
          });
        });
    }

    const feesOverride = {};

    [
      "credit_card_fee",
      "refrigerated_delivery_fee",
      "late_fee",
      "fuel_surcharge",
    ].forEach((feeName) => {
      if (invoice[feeName] !== invoice.of_default_values[feeName]) {
        feesOverride[feeName] = invoice[feeName];
      }
    });

    if (Object.keys(feesOverride).length) {
      await backend
        .patch(`${API_URL}orders/${orderId}/invoice`, feesOverride)
        .then(({ data }) => {
          setLoadingFlag(false);
          setFinishedFlag(true);

          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
          const errorData = error.response.data;

          setErrorInfo({
            error: true,
            message:
              typeof errorData === "object"
                ? errorData.hasOwnProperty("message")
                  ? errorData.message
                  : errorData.detail
                : error.message,
          });
        });
    }
  };

  const handleClickPrint = () => {
    const pdfFile = generateDocument(invoice);
    const fileURL = URL.createObjectURL(pdfFile);

    window.open(fileURL);
  };

  const handleClickPaymentReady = async (value) => {
    const endpointVal = value ? "setpayable" : "setnotpayable";

    await backend
      .post(`${API_URL}orders/${orderId}/invoice/${endpointVal}`)
      .then(({ data }) => {
        setInvoice((prevState) => ({ ...prevState, payable: value }));
      })
      .catch((error) => {
        console.log(error);
        const errorData = error.response.data;

        setErrorInfo({
          error: true,
          message:
            typeof errorData === "object"
              ? errorData.hasOwnProperty("message")
                ? errorData.message
                : errorData.detail
              : error.message,
        });
      });
  };

  const handleClickPaymentModal = async () => {
    // await backend.post(`${API_URL}orders/${orderId}/invoice/setpayable`);

    await backend
      .get(`${API_URL}orders/${orderId}/invoice/paymentpreview`)
      .then(({ data }) => {
        setPaymentData(data);
        if (data.hasOwnProperty("payment_method_options")) {
          const payMethod = data.payment_method_options.includes("ach")
            ? "ach"
            : data.payment_method_options[0];

          setPaymentMethod(payMethod);
          setPaymentSummary(data.invoice_payment_summary[payMethod]);
        }
        togglePaymentModal();
      })
      .catch((error) => {
        console.log(error);
        const errorData = error.response.data;

        setErrorInfo({
          error: true,
          message:
            typeof errorData === "object"
              ? errorData.hasOwnProperty("message")
                ? errorData.message
                : errorData.detail
              : error.message,
        });
      });
  };

  const handleClickPaymentContinue = async () => {
    setLoadingFlag(true);

    const payloadObj = { payment_method: paymentMethod };

    await backend
      .post(`${API_URL}orders/${orderId}/invoice/payment`, payloadObj)
      .then(({ data }) => {
        setPaymentIntent(data);
        if (data.hasOwnProperty("invoice_payment_summary")) {
          setPaymentSummary(data.invoice_payment_summary);
        }
        setLoadingFlag(false);
      })
      .catch((error) => {
        console.log(error);
        const errorData = error.response.data;

        setErrorInfo({
          error: true,
          message:
            typeof errorData === "object"
              ? errorData.hasOwnProperty("message")
                ? errorData.message
                : errorData.detail
              : error.message,
        });
      });
  };

  const togglePaymentModal = () => setPaymentModal(!paymentModal);

  const handleClickPaymentMethod = (payMethod) => {
    setPaymentMethod(payMethod);
    setPaymentSummary(paymentData.invoice_payment_summary[payMethod]);
    setPaymentIntent(null);
  };

  const dismissPaymentModal = () => {
    setLoadingFlag(false);
    setFinishedFlag(false);
    setPaymentData(null);
    setPaymentMethod(null);
    setPaymentIntent(null);
    togglePaymentModal();
  };

  const paymentModalContent = (
    <div
      className={classes.modal}
      style={{
        maxHeight: "95vh",
        overflowY: "auto",
      }}
    >
      {paymentData && (
        <>
          <Stack spacing={2} direction="row" justifyContent="center">
            {paymentData.payment_method_options &&
              paymentData.payment_method_options.map((item) => (
                <Button
                  key={`paymentMethod-${item}`}
                  variant={paymentMethod === item ? "contained" : "text"}
                  style={{ borderRadius: 30 }}
                  onClick={() => handleClickPaymentMethod(item)}
                >
                  {item}
                </Button>
              ))}
          </Stack>
          <Typography variant="h6" component="div">
            Payment Summary
          </Typography>
          <TableContainer>
            <Table>
              <TableBody>
                {paymentSummary !== null &&
                  Object.keys(paymentSummary).map((summary, index) => (
                    <TableRow
                      key={`paymentSummary-${index}`}
                      hover
                      tabIndex={-1}
                      className={classes.tableBody}
                    >
                      <TableCell
                        style={{
                          textAlign: "right",
                          textTransform: "capitalize",
                        }}
                      >
                        <b>{summary.replaceAll("_", " ")}:</b>
                      </TableCell>
                      <TableCell>{`$ ${paymentSummary[summary].toFixed(
                        2,
                      )}`}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
      <br />
      {!loadingFlag && paymentIntent === null && (
        <Stack spacing={2} direction="row" justifyContent="right">
          <Button onClick={() => dismissPaymentModal()}>Cancel</Button>
          <Button
            variant="contained"
            color="success"
            onClick={() => {
              handleClickPaymentContinue();
            }}
          >
            Continue
          </Button>
        </Stack>
      )}
      {paymentIntent !== null && (
        <Elements
          options={{
            clientSecret: paymentIntent.stripe_client_secret,
            customerSessionClientSecret:
              paymentIntent.customer_session_client_secret,
            appearance,
            loader,
          }}
          stripe={stripePromise}
        >
          <Payment
            {...props}
            dismissPaymentModal={dismissPaymentModal}
            returnUrl={window.location.href}
          />
        </Elements>
      )}
      {loadingFlag && (
        <>
          <div align="center">
            <CircularProgress />
            <div>{`Obtaining payment information`}</div>
          </div>
          {errorInfo.error && (
            <>
              <br />
              <br />
              {`There was an error while saving the price overrides`}
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {errorInfo.message}
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => dismissConfirmOverrideModal()}
                  className={classes.button}
                >
                  Continue
                </Button>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );

  const togglePaymentDetailsModal = () =>
    setPaymentDetailsModal(!paymentDetailsModal);

  const paymentDetailsModalContent = (
    <div className={classes.modal}>
      {paymentDetails.length && (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <Typography variant="h6" component="div">
              <b>{`$${paymentDetails[0].payment_amount} `}</b>USD
              <CheckCircleIcon color="success" />
            </Typography>
          </Grid>
          {paymentDetails[0].error_message !== "" && (
            <Grid item xs={12}>
              <b>Error message: </b>
              {paymentDetails[0].error_message}
            </Grid>
          )}
          <Grid item xs={6}>
            <b>Created: </b>
            {paymentDetails[0].created_date.split("T")[0]}
          </Grid>
          <Grid item xs={6}>
            <b>Updated: </b>
            {paymentDetails[0].modified_date.split("T")[0]}
          </Grid>
          <Grid item xs={12}>
            <Grid item xs={12} sm={12}>
              <Typography variant="h6" component="div">
                Payment Breakdown
              </Typography>
            </Grid>

            <Grid container spacing={0}>
              <Grid item xs={8}>
                Payment amount
              </Grid>
              <Grid
                item
                xs={4}
                textAlign="right"
              >{`$${paymentDetails[0].stripe_payment_intent.payment_amount.toFixed(
                2,
              )} USD`}</Grid>
              {paymentDetails[0].stripe_payment_intent.fees.map(
                (feeItem, idx) => (
                  <Fragment key={`stripe-fee-${idx}`}>
                    <Grid item xs={8}>
                      {feeItem.description}
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      textAlign="right"
                    >{`- $${feeItem.amount.toFixed(2)} USD`}</Grid>
                  </Fragment>
                ),
              )}
              {paymentDetails[0].stripe_payment_intent.capture_method ===
                "manual" && (
                <>
                  <Grid item xs={8}>
                    Refunded amount
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    textAlign="right"
                  >{`- $${paymentDetails[0].stripe_payment_intent.amount_refunded.toFixed(
                    2,
                  )} USD`}</Grid>
                </>
              )}
              <Grid item xs={8}>
                <b>Net amount</b>
              </Grid>
              <Grid item xs={4} textAlign="right">
                <b>{`$${paymentDetails[0].stripe_payment_intent.net_amount.toFixed(
                  2,
                )} USD`}</b>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}></Grid>
          <Grid item xs={12}>
            <Grid item xs={12} sm={12}>
              <Typography variant="h6" component="div">
                Payment method
              </Typography>
            </Grid>
            {Object.keys(
              paymentDetails[0].stripe_payment_intent.payment_method_details,
            ).map((dItem) => (
              <Grid
                key={dItem}
                item
                xs={12}
                style={{ textTransform: "capitalize" }}
              >
                <b>{dItem.replace("_", " ")}: </b>
                {dItem === "type"
                  ? paymentDetails[0].stripe_payment_intent
                      .payment_method_details.type === "us_bank_account"
                    ? "ACH"
                    : paymentDetails[0].stripe_payment_intent
                        .payment_method_details.type
                  : dItem === "last4"
                    ? `**** ${paymentDetails[0].stripe_payment_intent.payment_method_details.last4}`
                    : paymentDetails[0].stripe_payment_intent
                        .payment_method_details[dItem]}
              </Grid>
            ))}
          </Grid>
          <Grid item xs={12} sm={12}>
            <div align="right">
              <Button
                onClick={() => togglePaymentDetailsModal()}
                className={classes.button}
              >
                Close
              </Button>
            </div>
          </Grid>
        </Grid>
      )}
    </div>
  );

  return (
    <>
      <CssBaseline />
      <Container>
        {errorInfo.error && invoice === null ? (
          <>
            There was an issue trying to get the invoice information for
            <b> Order {orderId}</b>.
            <br />
            <br />
            {`Error: ${errorInfo.message}`}
          </>
        ) : (
          <>
            <Modal open={finalizeInvoiceModal}>
              {finalizeInvoiceModalContent}
            </Modal>
            <Modal open={invoiceShareModal}>{invoiceShareContent}</Modal>
            <Modal open={regenerateInvoiceModal}>
              {regenerateInvoiceModalContent}
            </Modal>
            <Modal open={confirmOverrideModal}>
              {confirmOverrideModalContent}
            </Modal>
            <Modal open={paymentModal}>{paymentModalContent}</Modal>
            <Modal open={paymentDetailsModal}>
              {paymentDetailsModalContent}
            </Modal>
            <Grid container spacing={3}>
              <Grid item xs={5} sm={2} alignSelf="center">
                <Typography variant="h6" component="div">
                  <img src={Logo} alt="logo" width="100%" height="auto" />
                </Typography>
              </Grid>
              <Grid item xs={7} sm={7} alignSelf="center">
                Friendly Foods, Inc.
                <br />
                3336 S La Cienega Blvd Ste 113
                <br />
                Los Angeles, CA 90016
                <br />
                323-653-5900
              </Grid>
              <Grid item xs={12} sm={3}>
                <Grid container spacing={0}>
                  <Grid item xs={true}>
                    <Typography variant="h6" component="div">
                      Invoice {` #${orderId}`}
                    </Typography>
                  </Grid>
                  <Grid item xs="auto">
                    <IconButton
                      variant="contained"
                      onClick={() => handleClickPrint()}
                    >
                      <PrintIcon color="inherit" />
                    </IconButton>
                  </Grid>
                  {currentUserStore && currentUserStore.is_staff ? (
                    <>
                      <Grid item xs="auto">
                        <IconButton
                          variant="contained"
                          onClick={toggleInvoiceShareModal}
                        >
                          <MailIcon color="inherit" />
                        </IconButton>
                      </Grid>
                      {invoice !== null &&
                        !["p", "pe"].includes(invoice.paid_status) &&
                        !finalizeInvoice && (
                          <>
                            <Grid item xs="auto">
                              <IconButton
                                variant="contained"
                                onClick={() =>
                                  overridden && overriddenDirty
                                    ? toggleConfirmOverrideModal()
                                    : toggleOverridden()
                                }
                              >
                                {overridden ? (
                                  <VisibilityIcon color="inherit" />
                                ) : (
                                  <EditIcon color="inherit" />
                                )}
                              </IconButton>
                            </Grid>
                            <Grid item xs="auto">
                              <IconButton
                                variant="contained"
                                onClick={toggleRegenerateInvoiceModal}
                              >
                                <RefreshIcon color="inherit" />
                              </IconButton>
                            </Grid>
                          </>
                        )}
                      {finalizeInvoice && (
                        <>
                          <Grid item xs="auto">
                            <Tooltip title="This invoice has been finalized and cannot be edited.">
                              <IconButton variant="contained">
                                <LockIcon color="inherit" />
                              </IconButton>
                            </Tooltip>
                          </Grid>
                        </>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </Grid>
                <Typography variant="subtitle1">
                  <strong>Customer: </strong>
                  {invoice ? invoice.company_location_name : "Unknown"}
                </Typography>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Date</TableCell>
                        <TableCell>Order #</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>
                          {invoice && invoice.order_delivery_date.split("T")[0]}
                        </TableCell>
                        <TableCell>{invoice && invoice.order_id}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              <Grid item xs={1}></Grid>
              <Grid item xs={12} sm={3}>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Bill To</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell style={{ whiteSpace: "pre" }}>
                          {invoice !== null ? (
                            <>
                              {invoice.company_location_name || ""}
                              <br />
                              {invoice.bill_to_address !== null ? (
                                <>{invoice.bill_to_address}</>
                              ) : (
                                <></>
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              <Grid item xs={1}></Grid>
              <Grid item xs={12} sm={3}>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Ship To</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell style={{ whiteSpace: "pre" }}>
                          {invoice !== null ? (
                            <>
                              {invoice.company_location_name || ""}
                              <br />
                              {invoice.ship_to_address !== null ? (
                                <>{invoice.ship_to_address}</>
                              ) : (
                                <></>
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              <Grid item xs={1}></Grid>
              <Grid item xs={12} sm={3}>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Ship From</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell style={{ whiteSpace: "pre" }}>
                          {invoice !== null ? (
                            <>
                              FF Warehouse
                              <br />
                              {invoice.ship_from_address !== null ? (
                                <>{invoice.ship_from_address}</>
                              ) : (
                                <></>
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              <Grid item xs={12} sm={1}></Grid>
              {invoice !== null && (
                <Grid
                  item
                  xs={12}
                  sm={3}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    rowGap: 10,
                  }}
                >
                  {currentUserStore &&
                    currentUserStore.is_staff &&
                    invoice?.cod_payments_enabled === true &&
                    !["p", "pe", "c"].includes(invoice?.paid_status) && (
                      <Button
                        variant="contained"
                        onClick={() => toggleFinalizeInvoiceModal()}
                        color="info"
                      >
                        Finalize Invoice
                      </Button>
                    )}
                  {props.location.search.includes(
                    "redirect_status=succeeded",
                  ) || ["p", "pe"].includes(invoice.paid_status) ? (
                    <Stack
                      direction="row"
                      spacing={1}
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                        background: "green",
                        padding: 8,
                        paddingRight: 16,
                        borderRadius: 25,
                        color: "white",
                        marginRight: 0,
                      }}
                    >
                      <PaidIcon color="white" />
                      <Typography variant="h6" component="div" color="white">
                        {`Paid ${
                          invoice.paid_status === "pe" ? "Externally" : ""
                        }`}
                      </Typography>
                    </Stack>
                  ) : (
                    <>
                      {currentUserStore &&
                        currentUserStore.is_staff &&
                        invoice?.company_location_payments_enabled === true && (
                          <FormControlLabel
                            control={
                              <Switch
                                name="payable"
                                checked={invoice.payable || false}
                                onChange={(e, value) =>
                                  handleClickPaymentReady(value)
                                }
                                color="default"
                                checkedIcon={<PaidIcon />}
                              />
                            }
                            label="Ready for Payment"
                            style={{
                              background: "#b35a4c",
                              padding: 8,
                              paddingRight: 16,
                              borderRadius: 25,
                              color: "#fff",
                              marginRight: 0,
                            }}
                          />
                        )}
                      {invoice.payable && userCanPay && (
                        <>
                          <Button
                            variant="contained"
                            onClick={handleClickPaymentModal}
                            color="success"
                          >
                            Pay Now
                          </Button>
                        </>
                      )}
                    </>
                  )}
                  {currentUserStore &&
                    currentUserStore.is_staff &&
                    paymentDetails.length > 0 && (
                      <Grid container spacing={0} textAlign="center">
                        <Grid item xs={12}>
                          <b>Payment Details</b>
                          <IconButton
                            variant="contained"
                            onClick={() => togglePaymentDetailsModal()}
                          >
                            <InfoIcon color="inherit" />
                          </IconButton>
                          <LinkE
                            href={`${paymentDetails[0].stripe_payment_intent.url}`}
                            target="_blank"
                          >
                            <Tooltip title="Stripe details">
                              <IconButton aria-label="stripe details">
                                <OpenInNewIcon />
                              </IconButton>
                            </Tooltip>
                          </LinkE>
                        </Grid>
                        <Grid item xs={12}>
                          <b>****</b>
                          {
                            paymentDetails[0].stripe_payment_intent
                              .payment_method_details.last4
                          }
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <b>Amount: </b>
                          {`$${paymentDetails[0].payment_amount.toFixed(2)}`}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <b>Status: </b>
                          {paymentDetails[0].status_label}
                        </Grid>
                      </Grid>
                    )}
                </Grid>
              )}
              {overridden && (
                <Grid item xs={12} style={{ textAlign: "right" }}>
                  <IconButton
                    variant="contained"
                    onClick={() => toggleConfirmOverrideModal(3)}
                    disabled={!hasOverrides}
                  >
                    <Tooltip title="Reset overrides">
                      <CachedIcon color={!hasOverrides ? "inherit" : "info"} />
                    </Tooltip>
                  </IconButton>
                  <IconButton
                    variant="contained"
                    onClick={() => toggleConfirmOverrideModal(2)}
                    disabled={!overriddenDirty}
                  >
                    <Tooltip title="Discard changes">
                      <DeleteIcon color="inherit" />
                    </Tooltip>
                  </IconButton>
                  <IconButton
                    variant="contained"
                    onClick={() => toggleConfirmOverrideModal(1)}
                    disabled={!overriddenDirty}
                  >
                    <Tooltip title="Save">
                      <SaveIcon
                        color={!overriddenDirty ? "inherit" : "success"}
                      />
                    </Tooltip>
                  </IconButton>
                </Grid>
              )}
              <Grid item xs={12}>
                <TableContainer>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        {columns.map((column) => (
                          <TableCell
                            key={`header-${column.id}`}
                            align={column.align}
                            style={{
                              width: column.width,
                              minWidth: column.width,
                            }}
                          >
                            {column.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {invoice && invoice.items.length ? (
                        <>
                          {invoice.items.map((row, index) => (
                            <Fragment key={`row-${index}`}>
                              <TableRow
                                hover
                                tabIndex={-1}
                                className={classes.tableBody}
                              >
                                {columns.map((column) => (
                                  <TableCell
                                    key={`column-${column.id}-row-${index}`}
                                    align={column.align}
                                    style={{ verticalAlign: "middle" }}
                                  >
                                    {orderItemsCellValue(row, column, index)}
                                    {["case_price", "total"].includes(
                                      column.id,
                                    ) && overridden ? (
                                      <></>
                                    ) : (
                                      orderItemsCellExtra(row, column)
                                    )}
                                    {row["surcharges"].length &&
                                    ["name", "case_price", "total"].includes(
                                      column.id,
                                    ) &&
                                    overridden ? (
                                      row["surcharges"].map(
                                        (surcharge, surchIndex) => (
                                          <Fragment
                                            key={`column-${column.id}-row-${index}-surcharge-${surchIndex}`}
                                          >
                                            {column.id === "case_price" ? (
                                              <>
                                                {row.case_price !== null ? (
                                                  <br />
                                                ) : (
                                                  <div style={{ height: 40 }} />
                                                )}
                                                <TextField
                                                  fullWidth
                                                  InputProps={{
                                                    inputProps: {
                                                      autoComplete: "off",
                                                    },
                                                    endAdornment:
                                                      overriddenEndorment(
                                                        `${column.id}-${index}-surcharge-${surchIndex}`,
                                                        row,
                                                      ),
                                                  }}
                                                  size="small"
                                                  type="number"
                                                  variant="outlined"
                                                  label={surcharge.name}
                                                  name={`${column.id}-${index}-surcharge-${surchIndex}`}
                                                  value={
                                                    (surcharge.invoice_override_price !==
                                                    null
                                                      ? surcharge.invoice_override_price
                                                      : surcharge.unit_price) ||
                                                    ""
                                                  }
                                                  onChange={handleChange}
                                                  style={{
                                                    background: overriddenStyle(
                                                      `${column.id}-${index}-surcharge-${surchIndex}`,
                                                      row,
                                                    ),
                                                    marginTop:
                                                      row.case_price !== null
                                                        ? 8
                                                        : 0,
                                                  }}
                                                />
                                              </>
                                            ) : column.id === "total" ? (
                                              <>
                                                <br />
                                                <TextField
                                                  fullWidth
                                                  InputProps={{
                                                    inputProps: {
                                                      autoComplete: "off",
                                                    },
                                                    endAdornment:
                                                      overriddenEndorment(
                                                        `${column.id}-${index}-surcharge-${surchIndex}`,
                                                        row,
                                                      ),
                                                  }}
                                                  size="small"
                                                  variant="outlined"
                                                  type="number"
                                                  label={surcharge.name}
                                                  name={`${column.id}-${index}-surcharge-${surchIndex}`}
                                                  value={
                                                    (surcharge.invoice_override_total !==
                                                    null
                                                      ? surcharge.invoice_override_total
                                                      : surcharge.total) || ""
                                                  }
                                                  onChange={handleChange}
                                                  style={{
                                                    background: overriddenStyle(
                                                      `${column.id}-${index}-surcharge-${surchIndex}`,
                                                      row,
                                                    ),
                                                    marginTop: 8,
                                                  }}
                                                />
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                          </Fragment>
                                        ),
                                      )
                                    ) : (
                                      <></>
                                    )}
                                  </TableCell>
                                ))}
                              </TableRow>
                            </Fragment>
                          ))}
                          {invoice.credits.length > 0 && (
                            <>
                              <TableRow style={{ background: "#f0f0f0" }}>
                                <TableCell colSpan={7} align="center">
                                  <b>Credits</b>
                                </TableCell>
                              </TableRow>
                              {invoice.credits.map((credit, index) => (
                                <TableRow
                                  hover
                                  tabIndex={-1}
                                  className={classes.tableBody}
                                  key={`credit-row-${index}`}
                                >
                                  <TableCell align="center">
                                    {credit.unit_quantity > 0
                                      ? credit.unit_quantity * -1
                                      : ""}
                                  </TableCell>
                                  <TableCell align="center">
                                    {credit.case_quantity > 0
                                      ? credit.case_quantity * -1
                                      : ""}
                                  </TableCell>
                                  <TableCell>
                                    {credit.product_data
                                      ? credit.product_data.item_code
                                          ?.item_code || ""
                                      : ""}
                                  </TableCell>
                                  <TableCell>
                                    {credit.product_data
                                      ? credit.product_data.name || ""
                                      : credit.description || ""}
                                    {credit.reason ||
                                    credit.invoice_reference ? (
                                      <>
                                        <br />
                                        {credit.reason ? (
                                          <>
                                            <b>Reason: </b>
                                            {credit.reason}{" "}
                                          </>
                                        ) : (
                                          ""
                                        )}
                                        {credit.invoice_reference ? (
                                          <>
                                            <b>Reference: </b>
                                            {credit.invoice_reference}
                                          </>
                                        ) : (
                                          ""
                                        )}
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </TableCell>
                                  <TableCell align="center">
                                    {credit.unit_quantity > 0
                                      ? `$${credit.unit_price?.toFixed(2)}`
                                      : ""}
                                  </TableCell>
                                  <TableCell align="center">
                                    {credit.case_quantity > 0
                                      ? `$${credit.case_price?.toFixed(2)}`
                                      : ""}
                                  </TableCell>
                                  <TableCell align="center">
                                    {credit.total !== null
                                      ? `-$${credit.total.toFixed(2)}`
                                      : ""}
                                  </TableCell>
                                </TableRow>
                              ))}
                            </>
                          )}
                          <TableRow
                            hover
                            tabIndex={-1}
                            className={classes.tableBody}
                          >
                            <TableCell colSpan={5}></TableCell>
                            <TableCell align="center">
                              <b>Subtotal</b>
                            </TableCell>
                            <TableCell align="center">{`$${invoice.subtotal.toFixed(
                              2,
                            )}`}</TableCell>
                          </TableRow>
                          {invoice.credit_card_fee ? (
                            <TableRow
                              hover
                              tabIndex={-1}
                              className={classes.tableBody}
                            >
                              <TableCell colSpan={5}></TableCell>
                              <TableCell align="center">
                                <b>Credit Card Fee</b>
                              </TableCell>
                              <TableCell align="center">
                                {overridden ? (
                                  <TextField
                                    fullWidth
                                    InputProps={{
                                      inputProps: {
                                        autoComplete: "off",
                                      },
                                      endAdornment: overriddenEndorment(
                                        "credit_card_fee",
                                        invoice,
                                      ),
                                    }}
                                    size="small"
                                    variant="outlined"
                                    type="number"
                                    label="Credit Card Fee"
                                    name="credit_card_fee"
                                    value={
                                      (invoice && invoice.credit_card_fee) || ""
                                    }
                                    onChange={handleChange}
                                    style={{
                                      background: overriddenStyle(
                                        "credit_card_fee",
                                        invoice,
                                      ),
                                    }}
                                  />
                                ) : (
                                  `$${(invoice.credit_card_fee || 0).toFixed(
                                    2,
                                  )}`
                                )}
                              </TableCell>
                            </TableRow>
                          ) : (
                            <></>
                          )}
                          {overridden || invoice.refrigerated_delivery_fee ? (
                            <TableRow
                              hover
                              tabIndex={-1}
                              className={classes.tableBody}
                            >
                              <TableCell colSpan={5}></TableCell>
                              <TableCell align="center">
                                <b>Refrigerated Delivery Fee</b>
                              </TableCell>
                              <TableCell align="center">
                                {overridden ? (
                                  <TextField
                                    fullWidth
                                    InputProps={{
                                      inputProps: {
                                        autoComplete: "off",
                                      },
                                      endAdornment: overriddenEndorment(
                                        "refrigerated_delivery_fee",
                                        invoice,
                                      ),
                                    }}
                                    size="small"
                                    variant="outlined"
                                    type="number"
                                    label="Refrigerated Delivery Fee"
                                    name="refrigerated_delivery_fee"
                                    value={
                                      (invoice &&
                                        invoice.refrigerated_delivery_fee) ||
                                      ""
                                    }
                                    onChange={handleChange}
                                    style={{
                                      background: overriddenStyle(
                                        "refrigerated_delivery_fee",
                                        invoice,
                                      ),
                                    }}
                                  />
                                ) : (
                                  `$${(
                                    invoice.refrigerated_delivery_fee || 0
                                  ).toFixed(2)}`
                                )}
                              </TableCell>
                            </TableRow>
                          ) : (
                            <></>
                          )}
                          {overridden || invoice.late_fee ? (
                            <TableRow
                              hover
                              tabIndex={-1}
                              className={classes.tableBody}
                            >
                              <TableCell colSpan={5}></TableCell>
                              <TableCell align="center">
                                <b>Late Fee</b>
                              </TableCell>
                              <TableCell align="center">
                                {overridden ? (
                                  <TextField
                                    fullWidth
                                    InputProps={{
                                      inputProps: {
                                        autoComplete: "off",
                                      },
                                      endAdornment: overriddenEndorment(
                                        "late_fee",
                                        invoice,
                                      ),
                                    }}
                                    size="small"
                                    variant="outlined"
                                    type="number"
                                    label="Late Fee"
                                    name="late_fee"
                                    value={(invoice && invoice.late_fee) || ""}
                                    onChange={handleChange}
                                    style={{
                                      background: overriddenStyle(
                                        "late_fee",
                                        invoice,
                                      ),
                                    }}
                                  />
                                ) : (
                                  `$${(invoice.late_fee || 0).toFixed(2)}`
                                )}
                              </TableCell>
                            </TableRow>
                          ) : (
                            <></>
                          )}
                          {overridden || invoice.fuel_surcharge ? (
                            <TableRow
                              hover
                              tabIndex={-1}
                              className={classes.tableBody}
                            >
                              <TableCell colSpan={5}></TableCell>
                              <TableCell align="center">
                                <b>Fuel Surcharge</b>
                              </TableCell>
                              <TableCell align="center">
                                {overridden ? (
                                  <TextField
                                    fullWidth
                                    InputProps={{
                                      inputProps: {
                                        autoComplete: "off",
                                      },
                                      endAdornment: overriddenEndorment(
                                        "fuel_surcharge",
                                        invoice,
                                      ),
                                    }}
                                    size="small"
                                    variant="outlined"
                                    type="number"
                                    label="Fuel Surcharge"
                                    name="fuel_surcharge"
                                    value={
                                      (invoice && invoice.fuel_surcharge) || ""
                                    }
                                    onChange={handleChange}
                                    style={{
                                      background: overriddenStyle(
                                        "fuel_surcharge",
                                        invoice,
                                      ),
                                    }}
                                  />
                                ) : (
                                  `$${(invoice.fuel_surcharge || 0).toFixed(2)}`
                                )}
                              </TableCell>
                            </TableRow>
                          ) : (
                            <></>
                          )}
                          <TableRow
                            hover
                            tabIndex={-1}
                            className={classes.tableBody}
                          >
                            <TableCell colSpan={5}></TableCell>
                            <TableCell align="center">
                              <b>Taxes</b>
                            </TableCell>
                            <TableCell align="center">{`$${(
                              invoice.tax_total || 0
                            ).toFixed(2)}`}</TableCell>
                          </TableRow>
                          {invoice?.credit_total ? (
                            <TableRow
                              hover
                              tabIndex={-1}
                              className={classes.tableBody}
                            >
                              <TableCell colSpan={5}></TableCell>
                              <TableCell align="center">
                                <b>Credits</b>
                              </TableCell>
                              <TableCell align="center">{`-$${Math.abs(
                                invoice.credit_total || 0,
                              ).toFixed(2)}`}</TableCell>
                            </TableRow>
                          ) : (
                            <></>
                          )}
                          <TableRow
                            hover
                            tabIndex={-1}
                            className={classes.tableBody}
                          >
                            <TableCell colSpan={5}></TableCell>
                            <TableCell align="center">
                              <b>Grand Total</b>
                            </TableCell>
                            <TableCell align="center">{`$${invoice.grand_total.toFixed(
                              2,
                            )}`}</TableCell>
                          </TableRow>
                        </>
                      ) : (
                        <>
                          <TableRow
                            hover
                            tabIndex={-1}
                            className={classes.tableBody}
                          >
                            <TableCell colSpan={7}>
                              There are no picked items yet
                            </TableCell>
                          </TableRow>
                        </>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              {invoice &&
                invoice.items.length > 0 &&
                currentUserStore &&
                currentUserStore.is_staff &&
                !finalizeInvoice && (
                  <Grid item xs={12}>
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      style={{ marginBottom: 8 }}
                    >
                      <Stack
                        direction="row"
                        alignItems="center"
                        spacing={1}
                        onClick={() => setCreditsOpen((o) => !o)}
                        style={{
                          cursor: "pointer",
                          userSelect: "none",
                          flexGrow: creditsOpen ? 0 : 1,
                        }}
                      >
                        {creditsOpen ? (
                          <ExpandLessIcon fontSize="small" />
                        ) : (
                          <ExpandMoreIcon fontSize="small" />
                        )}
                        <Typography variant="subtitle1">
                          <b>Credits</b>
                        </Typography>
                        {credits.filter((c) => !c._delete).length > 0 && (
                          <Chip
                            label={credits.filter((c) => !c._delete).length}
                            size="small"
                            color="primary"
                            variant="outlined"
                          />
                        )}
                      </Stack>
                      {creditsOpen && (
                        <Button
                          variant="contained"
                          // startIcon={<AddIcon />}
                          onClick={handleAddCredit}
                        >
                          Add Credit
                        </Button>
                      )}
                    </Stack>
                    <Collapse in={creditsOpen}>
                      <TableContainer>
                        <Table stickyHeader aria-label="credits table">
                          <TableHead>
                            <TableRow>
                              {columns.map((column) => (
                                <TableCell
                                  key={`credits-header-${column.id}`}
                                  align={column.align}
                                  style={{
                                    width: column.width,
                                    minWidth: column.width,
                                  }}
                                >
                                  {column.label}
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {credits.map((credit, index) =>
                              credit._delete ? null : (
                                <TableRow
                                  key={`credit-${index}`}
                                  hover
                                  tabIndex={-1}
                                  className={classes.tableBody}
                                >
                                  <TableCell align="center">
                                    {credit.product_mode &&
                                    (credit.unit_type === "Unit" ||
                                      credit.unit_type === "Unit / Case") ? (
                                      <TextField
                                        size="small"
                                        type="number"
                                        value={credit.unit_quantity}
                                        label="Unit Qty"
                                        onChange={(e) =>
                                          handleCreditChange(
                                            index,
                                            "unit_quantity",
                                            e.target.value,
                                          )
                                        }
                                        inputProps={{
                                          autoComplete: "off",
                                          min: 0,
                                        }}
                                        style={{ width: 90 }}
                                      />
                                    ) : (
                                      ""
                                    )}
                                  </TableCell>
                                  <TableCell align="center">
                                    {credit.product_mode &&
                                    (credit.unit_type === "Case" ||
                                      credit.unit_type === "Unit / Case") ? (
                                      <TextField
                                        size="small"
                                        type="number"
                                        value={credit.case_quantity}
                                        label="Case Qty"
                                        onChange={(e) =>
                                          handleCreditChange(
                                            index,
                                            "case_quantity",
                                            e.target.value,
                                          )
                                        }
                                        inputProps={{
                                          autoComplete: "off",
                                          min: 0,
                                        }}
                                        style={{ width: 90 }}
                                      />
                                    ) : (
                                      ""
                                    )}
                                  </TableCell>
                                  <TableCell align="center">
                                    {credit.item_code || ""}
                                  </TableCell>
                                  <TableCell align="left">
                                    <Stack
                                      direction="row"
                                      alignItems="center"
                                      spacing={0.5}
                                    >
                                      {credit.product_mode ? (
                                        <Autocomplete
                                          size="small"
                                          sx={{ flex: 1 }}
                                          options={credit._productOptions}
                                          getOptionLabel={(opt) =>
                                            typeof opt === "string"
                                              ? opt
                                              : opt.name || ""
                                          }
                                          isOptionEqualToValue={(opt, val) =>
                                            opt.id === val.id
                                          }
                                          inputValue={credit._productInput}
                                          onInputChange={(_, value, reason) =>
                                            handleCreditProductInputChange(
                                              index,
                                              value,
                                              reason,
                                            )
                                          }
                                          onChange={(_, product) =>
                                            handleCreditProductSelect(
                                              index,
                                              product,
                                            )
                                          }
                                          filterOptions={(x) => x}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              fullWidth
                                              size="small"
                                              label="Search product"
                                            />
                                          )}
                                        />
                                      ) : (
                                        <TextField
                                          fullWidth
                                          size="small"
                                          sx={{ flex: 1 }}
                                          value={credit.description}
                                          label="Description"
                                          onChange={(e) =>
                                            handleCreditChange(
                                              index,
                                              "description",
                                              e.target.value,
                                            )
                                          }
                                          inputProps={{ autoComplete: "off" }}
                                        />
                                      )}
                                      {!Boolean(credit?.id) && (
                                        <Tooltip
                                          title={
                                            credit.product_mode
                                              ? "Switch to freeform text"
                                              : "Switch to product search"
                                          }
                                        >
                                          <IconButton
                                            size="small"
                                            onClick={() =>
                                              handleCreditModeToggle(index)
                                            }
                                          >
                                            <AutorenewIcon fontSize="small" />
                                          </IconButton>
                                        </Tooltip>
                                      )}
                                    </Stack>
                                    <Stack direction="row" spacing={1} mt={1}>
                                      <TextField
                                        size="small"
                                        sx={{ flex: 1 }}
                                        value={credit.reason || ""}
                                        label="Reason"
                                        onChange={(e) =>
                                          handleCreditChange(
                                            index,
                                            "reason",
                                            e.target.value,
                                          )
                                        }
                                        inputProps={{ autoComplete: "off" }}
                                      />
                                      <TextField
                                        size="small"
                                        sx={{ flex: 1 }}
                                        value={credit.invoice_reference || ""}
                                        label="Invoice Reference"
                                        onChange={(e) =>
                                          handleCreditChange(
                                            index,
                                            "invoice_reference",
                                            e.target.value,
                                          )
                                        }
                                        inputProps={{ autoComplete: "off" }}
                                      />
                                    </Stack>
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    style={{
                                      padding: credit.product_mode
                                        ? 8
                                        : "inherit",
                                    }}
                                  >
                                    {credit.product_mode &&
                                    credit.unit_quantity > 0 ? (
                                      <TextField
                                        size="small"
                                        type="number"
                                        value={credit.unit_price}
                                        label="Unit Price"
                                        onChange={(e) =>
                                          handleCreditChange(
                                            index,
                                            "unit_price",
                                            e.target.value,
                                          )
                                        }
                                        inputProps={{
                                          autoComplete: "off",
                                          min: 0,
                                        }}
                                        InputProps={{
                                          endAdornment:
                                            credit.unit_price !==
                                            credit.product_data
                                              .display_unit_price ? (
                                              <InputAdornment position="end">
                                                <IconButton
                                                  size="small"
                                                  aria-label="reset overridden value"
                                                  onClick={() =>
                                                    handleCreditChange(
                                                      index,
                                                      "unit_price",
                                                      credit.product_data
                                                        .display_unit_price,
                                                    )
                                                  }
                                                  style={{ padding: 0 }}
                                                >
                                                  <RestartAltIcon />
                                                </IconButton>
                                              </InputAdornment>
                                            ) : null,
                                        }}
                                        sx={{
                                          "& input[type=number]::-webkit-outer-spin-button":
                                            {
                                              WebkitAppearance: "none",
                                              margin: 0,
                                            },
                                          "& input[type=number]::-webkit-inner-spin-button":
                                            {
                                              WebkitAppearance: "none",
                                              margin: 0,
                                            },
                                        }}
                                        style={{ width: 90 }}
                                      />
                                    ) : credit.product_mode &&
                                      credit.unit_price !== null &&
                                      ["Unit", "Unit / Case"].includes(
                                        credit.unit_type,
                                      ) ? (
                                      <span
                                        style={{
                                          color: "rgba(0, 0, 0, 0.5)",
                                        }}
                                      >{`$${(+credit.unit_price).toFixed(2)}`}</span>
                                    ) : (
                                      ""
                                    )}
                                  </TableCell>
                                  <TableCell align="center">
                                    {credit.product_mode &&
                                    credit.case_quantity > 0 ? (
                                      <TextField
                                        size="small"
                                        type="number"
                                        value={credit.case_price}
                                        label="Case Price"
                                        onChange={(e) =>
                                          handleCreditChange(
                                            index,
                                            "case_price",
                                            e.target.value,
                                          )
                                        }
                                        inputProps={{
                                          autoComplete: "off",
                                          min: 0,
                                        }}
                                        InputProps={{
                                          endAdornment:
                                            credit.case_price !==
                                            credit.product_data
                                              .display_case_price ? (
                                              <InputAdornment position="end">
                                                <IconButton
                                                  size="small"
                                                  aria-label="reset overridden value"
                                                  onClick={() =>
                                                    handleCreditChange(
                                                      index,
                                                      "case_price",
                                                      credit.product_data
                                                        .display_case_price,
                                                    )
                                                  }
                                                  style={{ padding: 0 }}
                                                >
                                                  <RestartAltIcon />
                                                </IconButton>
                                              </InputAdornment>
                                            ) : null,
                                        }}
                                        sx={{
                                          "& input[type=number]::-webkit-outer-spin-button":
                                            {
                                              WebkitAppearance: "none",
                                              margin: 0,
                                            },
                                          "& input[type=number]::-webkit-inner-spin-button":
                                            {
                                              WebkitAppearance: "none",
                                              margin: 0,
                                            },
                                        }}
                                        style={{ width: 90 }}
                                      />
                                    ) : credit.product_mode &&
                                      credit.case_price !== null &&
                                      ["Case", "Unit / Case"].includes(
                                        credit.unit_type,
                                      ) ? (
                                      <span
                                        style={{
                                          color: "rgba(0, 0, 0, 0.5)",
                                        }}
                                      >{`$${(+credit.case_price).toFixed(2)}`}</span>
                                    ) : (
                                      ""
                                    )}
                                  </TableCell>
                                  <TableCell align="center">
                                    <TextField
                                      size="small"
                                      type="number"
                                      value={credit.total}
                                      label="Amount"
                                      onChange={(e) =>
                                        handleCreditChange(
                                          index,
                                          "total",
                                          e.target.value,
                                        )
                                      }
                                      inputProps={{
                                        autoComplete: "off",
                                        min: 0,
                                        step: "0.01",
                                      }}
                                      fullWidth
                                      InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <Tooltip title="Remove credit">
                                              <IconButton
                                                size="small"
                                                onClick={() =>
                                                  handleCreditDelete(index)
                                                }
                                              >
                                                <DeleteIcon fontSize="small" />
                                              </IconButton>
                                            </Tooltip>
                                          </InputAdornment>
                                        ),
                                      }}
                                      disabled={
                                        credit.product_mode &&
                                        credit.unit_quantity > 0 &&
                                        credit.case_quantity > 0
                                      }
                                    />
                                  </TableCell>
                                </TableRow>
                              ),
                            )}
                            <TableRow
                              hover
                              tabIndex={-1}
                              className={classes.tableBody}
                            >
                              <TableCell colSpan={5}></TableCell>
                              <TableCell align="center">
                                <b>Subtotal</b>
                              </TableCell>
                              <TableCell align="center">{`$${creditsSubtotal.toFixed(2)}`}</TableCell>
                            </TableRow>
                            {credits.filter((c) => !c._delete).length > 0 && (
                              <TableRow
                                hover
                                tabIndex={-1}
                                className={classes.tableBody}
                              >
                                <TableCell colSpan={5}></TableCell>
                                <TableCell align="center">
                                  <b>Credits</b>
                                </TableCell>
                                <TableCell align="center">{`$${creditsTotal.toFixed(2)}`}</TableCell>
                              </TableRow>
                            )}
                            <TableRow
                              hover
                              tabIndex={-1}
                              className={classes.tableBody}
                            >
                              <TableCell colSpan={5}></TableCell>
                              <TableCell align="center">
                                <b>Grand Total</b>
                              </TableCell>
                              <TableCell
                                align="center"
                                style={
                                  creditsOverflow
                                    ? { color: "red", fontWeight: "bold" }
                                    : {}
                                }
                              >{`$${(creditsSubtotal - creditsTotal).toFixed(
                                2,
                              )}`}</TableCell>
                            </TableRow>
                            {creditsDirty && (
                              <TableRow>
                                <TableCell colSpan={7} align="right">
                                  {creditsOverflow && (
                                    <span
                                      style={{ color: "red", marginRight: 8 }}
                                    >
                                      Credits cannot exceed the invoice total.
                                    </span>
                                  )}
                                  {creditsError && (
                                    <span
                                      style={{ color: "red", marginRight: 8 }}
                                    >
                                      {creditsError}
                                    </span>
                                  )}
                                  {creditsLoading ? (
                                    <CircularProgress size={24} />
                                  ) : (
                                    <Button
                                      variant="contained"
                                      color="success"
                                      onClick={handleSaveCredits}
                                      disabled={creditsOverflow}
                                    >
                                      Save Credits
                                    </Button>
                                  )}
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Collapse>
                  </Grid>
                )}
              <Grid
                item
                xs={12}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Link
                  to={`/api/orders/${orderId}/invoice/downloadexport`}
                  target="_blank"
                  style={{ marginLeft: theme.spacing(1) }}
                >
                  <Button variant="contained">Download CSV</Button>
                </Link>
                <Link
                  to={`/order/${orderId}`}
                  style={{ marginLeft: "10px", textDecoration: "none" }}
                >
                  <Button variant="contained">Back</Button>
                </Link>
              </Grid>
            </Grid>
          </>
        )}
      </Container>
    </>
  );
};

export default Invoice;
